(function(e){e.fn.ddslick=function(l){if(c[l]){return c[l].apply(this,Array.prototype.slice.call(arguments,1))}else{if(typeof l==="object"||!l){return c.init.apply(this,arguments)}else{e.error("Method "+l+" does not exists.")}}};var c={},d={data:[],keepJSONItemsOnTop:false,width:260,height:null,background:"#eee",selectText:"",defaultSelectedIndex:null,truncateDescription:true,imagePosition:"left",showSelectedHTML:true,clickOffToClose:true,embedCSS:true,onSelected:function(){}},i='<div class="dd-select"><input class="dd-selected-value" type="hidden" /><a class="dd-selected"></a><span class="dd-pointer dd-pointer-down"></span></div>',a='<ul class="dd-options"></ul>',b='<style id="css-ddslick" type="text/css">.dd-select{ border-radius:2px; border:solid 1px #ccc; position:relative; cursor:pointer;}.dd-desc { color:#aaa; display:block; overflow: hidden; font-weight:normal; line-height: 1.4em; }.dd-selected{ overflow:hidden; display:block; padding:10px; font-weight:bold;}.dd-pointer{ width:0; height:0; position:absolute; right:10px; top:50%; margin-top:-3px;}.dd-pointer-down{ border:solid 5px transparent; border-top:solid 5px #000; }.dd-pointer-up{border:solid 5px transparent !important; border-bottom:solid 5px #000 !important; margin-top:-8px;}.dd-options{ border:solid 1px #ccc; border-top:none; list-style:none; box-shadow:0px 1px 5px #ddd; display:none; position:absolute; z-index:2000; margin:0; padding:0;background:#fff; overflow:auto;}.dd-option{ padding:10px; display:block; border-bottom:solid 1px #ddd; overflow:hidden; text-decoration:none; color:#333; cursor:pointer;-webkit-transition: all 0.25s ease-in-out; -moz-transition: all 0.25s ease-in-out;-o-transition: all 0.25s ease-in-out;-ms-transition: all 0.25s ease-in-out; }.dd-options > li:last-child > .dd-option{ border-bottom:none;}.dd-option:hover{ background:#f3f3f3; color:#000;}.dd-selected-description-truncated { text-overflow: ellipsis; white-space:nowrap; }.dd-option-selected { background:#f6f6f6; }.dd-option-image, .dd-selected-image { vertical-align:middle; float:left; margin-right:5px; max-width:64px;}.dd-image-right { float:right; margin-right:15px; margin-left:5px;}.dd-container{ position:relative;}​ .dd-selected-text { font-weight:bold}​</style>';c.init=function(l){var l=e.extend({},d,l);if(e("#css-ddslick").length<=0&&l.embedCSS){e(b).appendTo("head")}return this.each(function(){var p=e(this),q=p.data("ddslick");if(!q){var n=[],o=l.data;p.find("option").each(function(){var w=e(this),v=w.data();n.push({text:e.trim(w.text()),value:w.val(),selected:w.is(":selected"),description:v.description,imageSrc:v.imagesrc})});if(l.keepJSONItemsOnTop){e.merge(l.data,n)}else{l.data=e.merge(n,l.data)}var m=p,s=e('<div id="'+p.attr("id")+'"></div>');p.replaceWith(s);p=s;p.addClass("dd-container").append(i).append(a);var n=p.find(".dd-select"),u=p.find(".dd-options");u.css({width:l.width});n.css({width:l.width,background:l.background});p.css({width:l.width});if(l.height!=null){u.css({height:l.height,overflow:"auto"})}e.each(l.data,function(v,w){if(w.selected){l.defaultSelectedIndex=v}u.append('<li><a class="dd-option">'+(w.value?' <input class="dd-option-value" type="hidden" value="'+w.value+'" />':"")+(w.imageSrc?' <img class="dd-option-image'+(l.imagePosition=="right"?" dd-image-right":"")+'" src="'+w.imageSrc+'" />':"")+(w.text?' <label class="dd-option-text">'+w.text+"</label>":"")+(w.description?' <small class="dd-option-description dd-desc">'+w.description+"</small>":"")+"</a></li>")});var t={settings:l,original:m,selectedIndex:-1,selectedItem:null,selectedData:null};p.data("ddslick",t);if(l.selectText.length>0&&l.defaultSelectedIndex==null){p.find(".dd-selected").html(l.selectText)}else{var r=(l.defaultSelectedIndex!=null&&l.defaultSelectedIndex>=0&&l.defaultSelectedIndex<l.data.length)?l.defaultSelectedIndex:0;j(p,r)}p.find(".dd-select").on("click.ddslick",function(){f(p)});p.find(".dd-option").on("click.ddslick",function(){j(p,e(this).closest("li").index())});if(l.clickOffToClose){u.addClass("dd-click-off-close");p.on("click.ddslick",function(v){v.stopPropagation()});e("body").on("click",function(){e(".dd-click-off-close").slideUp(50).siblings(".dd-select").find(".dd-pointer").removeClass("dd-pointer-up")})}}})};c.select=function(l){return this.each(function(){if(l.index!==undefined){j(e(this),l.index)}})};c.open=function(){return this.each(function(){var m=e(this),l=m.data("ddslick");if(l){f(m)}})};c.close=function(){return this.each(function(){var m=e(this),l=m.data("ddslick");if(l){k(m)}})};c.destroy=function(){return this.each(function(){var n=e(this),m=n.data("ddslick");if(m){var l=m.original;n.removeData("ddslick").unbind(".ddslick").replaceWith(l)}})};function j(q,s){var u=q.data("ddslick");var r=q.find(".dd-selected"),n=r.siblings(".dd-selected-value"),v=q.find(".dd-options"),l=r.siblings(".dd-pointer"),p=q.find(".dd-option").eq(s),m=p.closest("li"),o=u.settings,t=u.settings.data[s];q.find(".dd-option").removeClass("dd-option-selected");p.addClass("dd-option-selected");u.selectedIndex=s;u.selectedItem=m;u.selectedData=t;if(o.showSelectedHTML){r.html((t.imageSrc?'<img class="dd-selected-image'+(o.imagePosition=="right"?" dd-image-right":"")+'" src="'+t.imageSrc+'" />':"")+(t.text?'<label class="dd-selected-text">'+t.text+"</label>":"")+(t.description?'<small class="dd-selected-description dd-desc'+(o.truncateDescription?" dd-selected-description-truncated":"")+'" >'+t.description+"</small>":""))}else{r.html(t.text)}n.val(t.value);u.original.val(t.value);q.data("ddslick",u);k(q);g(q);if(typeof o.onSelected=="function"){o.onSelected.call(this,u)}}function f(p){var o=p.find(".dd-select"),m=o.siblings(".dd-options"),l=o.find(".dd-pointer"),n=m.is(":visible");e(".dd-click-off-close").not(m).slideUp(50);e(".dd-pointer").removeClass("dd-pointer-up");if(n){m.slideUp("fast");l.removeClass("dd-pointer-up")}else{m.slideDown("fast");l.addClass("dd-pointer-up")}h(p)}function k(l){l.find(".dd-options").slideUp(50);l.find(".dd-pointer").removeClass("dd-pointer-up").removeClass("dd-pointer-up")}function g(o){var n=o.find(".dd-select").css("height");var m=o.find(".dd-selected-description");var l=o.find(".dd-selected-image");if(m.length<=0&&l.length>0){o.find(".dd-selected-text").css("lineHeight",n)}}function h(l){l.find(".dd-option").each(function(){var p=e(this);var n=p.css("height");var o=p.find(".dd-option-description");var m=l.find(".dd-option-image");if(o.length<=0&&m.length>0){p.find(".dd-option-text").css("lineHeight",n)}})}})(jQuery);
var domReady = false; 
var selectFlag = true;
var exchRate = parseFloat(window.Shopify.currency.rate);
var moneyDecimal = true;
var currentGalleryIndex = 0;
var bundleTotalPrice = 0;
if (theme.currencySettings.money_format.indexOf('amount_no_decimals') > -1) {
  moneyDecimal = false;
}
var currencySymbol = theme.currencySettings.money_format.split('{{')[0];

if ($('.template-product').length > 0) {
  var customBundleProp = $.trim($('.bundle-option-wrapper').attr('data-custom-prop'));


  var currentCurrency = Currency.currentCurrency;
  var currencyCode = '';
  if (currentCurrency != 'AUD') {
    currencyCode = currentCurrency;
  }
  currentCurrency = Shopify.currency.active;

  var parentQty = 0;
  var parentInv = 0;
  var bundleUnit = '';
  var imageCombiSrc = '';

  var bundlePrice = '';
  var bundleComparePrice = '';
  
  $(function() {
    gallerySlider()

    


    
    $('body').on('click', '.product-page--images .modal--link', function() {
      var imgID = $(this).attr('data-id');
      $('.imageBoxModal .modal--link[data-id="'+imgID+'"]').trigger('click');
    });
    

    $('.product-page--thumbs-container').on('afterChange', function(event, slick){
        currentGalleryIndex = slick.currentSlide;
    });
    $('.productSlider').slick('slickGoTo', currentGalleryIndex);

    function setOptionSelectors() {
      new Shopify.OptionSelectors("variant-listbox", {
        product: product_json,
        onVariantSelected: selectCallback,
        enableHistoryState: true
      });
    }

    setOptionSelectors();


    if ($('.product-page-right .product-page--cart-form .size-button-container').length > 0) {
      $('.variants .selector-wrapper').hide();
    }
    if ($('body').hasClass('current-template-dropdown-variant') == true) {
      $('.variants .selector-wrapper').show();
      $('.size-button-container').hide();
    }


    // Get Bundle Price total
    var totalBundlePriceDisplay = function() {
      console.log('totalBundlePriceDisplay');


      var bundlePercentage = parseInt($('[data-bundle-percentage]').attr('data-bundle-percentage'));

      var percentageModifier = 1;
      if (isNaN(bundlePercentage)) {
        bundlePercentage = 0;
      }
      //var pPrice = parseInt($('[data-product-price]').attr('data-product-price'));

      var mainProductPrice = parseInt($('[data-product-price]').attr('data-product-price'));
      var bundleProduct1Price = parseInt($('select#bundledProduct1').find('option:selected').attr('data-price')) || 0;
      var bundleProduct2Price = parseInt($('select#bundledProduct2').find('option:selected').attr('data-price')) || 0;
      var bundleProduct3Price = parseInt($('select#bundledProduct3').find('option:selected').attr('data-price')) || 0;
      var bundleProduct4Price = parseInt($('select#bundledProduct4').find('option:selected').attr('data-price')) || 0;
      var bundleProduct5Price = parseInt($('select#bundledProduct5').find('option:selected').attr('data-price')) || 0;
      var bundleProduct6Price = parseInt($('select#bundledProduct6').find('option:selected').attr('data-price')) || 0;



      var mainProductPriceOrig = mainProductPrice;
      var bundleProduct1PriceOrig = bundleProduct1Price * parseInt($('select#bundledProduct1').find('option:selected').attr('data-qty')) || 0;
      var bundleProduct2PriceOrig = bundleProduct2Price * parseInt($('select#bundledProduct2').find('option:selected').attr('data-qty')) || 0;
      var bundleProduct3PriceOrig = bundleProduct3Price * parseInt($('select#bundledProduct3').find('option:selected').attr('data-qty')) || 0;
      var bundleProduct4PriceOrig = bundleProduct4Price * parseInt($('select#bundledProduct4').find('option:selected').attr('data-qty')) || 0;
      var bundleProduct5PriceOrig = bundleProduct5Price * parseInt($('select#bundledProduct5').find('option:selected').attr('data-qty')) || 0;
      var bundleProduct6PriceOrig = bundleProduct6Price * parseInt($('select#bundledProduct6').find('option:selected').attr('data-qty')) || 0;

      
      // bundle percentage override
      
      if (bundlePercentage > 0) {
        percentageModifier = ((100 - bundlePercentage) * .01).toFixed(2);
        percentageModifier = parseFloat(percentageModifier)

        percentageModifier0 = (bundlePercentage * .01).toFixed(2);
        percentageModifier0 = parseFloat(percentageModifier0)

        // if (pPrice == 0) {
        //   mainProductPrice = 0;
        //   mainProductPriceC = 0;
        // } else {
        //   mainProductPrice = (pPrice - ((pPrice * percentageModifier0).toFixed(0)));
        //   mainProductPriceC = pPrice;
        // }
        if (mainProductPrice > 0) {
          mainProductPrice = (mainProductPrice - (Math.round(mainProductPrice * percentageModifier0)));
        }  
        if (bundleProduct1Price > 0) {
          bundleProduct1Price = (bundleProduct1Price - (Math.round(bundleProduct1Price * percentageModifier0)));
        }
        if (bundleProduct2Price > 0) {
          bundleProduct2Price = (bundleProduct2Price - (Math.round(bundleProduct2Price * percentageModifier0)));
        }
        if (bundleProduct3Price > 0) {
          bundleProduct3Price = (bundleProduct3Price - (Math.round(bundleProduct3Price * percentageModifier0)));
        }
        if (bundleProduct4Price > 0) {
          bundleProduct4Price = (bundleProduct4Price - (Math.round(bundleProduct4Price * percentageModifier0)));
        }
        if (bundleProduct5Price > 0) {
          bundleProduct5Price = (bundleProduct5Price - (Math.round(bundleProduct5Price * percentageModifier0)));
        }
        if (bundleProduct6Price > 0) {
          bundleProduct6Price = (bundleProduct6Price - (Math.round(bundleProduct6Price * percentageModifier0)));
        }
      }
      //console.log('bundleProduct66Price:'+bundleProduct6Price); 
      bundleProduct1Price = bundleProduct1Price * (parseInt($('select#bundledProduct1').find('option:selected').attr('data-qty')) || 0);
      bundleProduct2Price = bundleProduct2Price * (parseInt($('select#bundledProduct2').find('option:selected').attr('data-qty')) || 0);
      bundleProduct3Price = bundleProduct3Price * (parseInt($('select#bundledProduct3').find('option:selected').attr('data-qty')) || 0);
      bundleProduct4Price = bundleProduct4Price * (parseInt($('select#bundledProduct4').find('option:selected').attr('data-qty')) || 0);
      bundleProduct5Price = bundleProduct5Price * (parseInt($('select#bundledProduct5').find('option:selected').attr('data-qty')) || 0);
      bundleProduct6Price = bundleProduct6Price * (parseInt($('select#bundledProduct6').find('option:selected').attr('data-qty')) || 0);

      // bundleProduct1Price = Math.trunc(bundleProduct1Price);
      // bundleProduct2Price = Math.trunc(bundleProduct2Price);
      // bundleProduct3Price = Math.trunc(bundleProduct3Price);
      // bundleProduct4Price = Math.trunc(bundleProduct4Price);
      // bundleProduct5Price = Math.trunc(bundleProduct5Price);
      // bundleProduct6Price = Math.trunc(bundleProduct6Price);

//       console.log(bundleProduct1Price);
// console.log(bundleProduct2Price);
// console.log(bundleProduct3Price);
// console.log(bundleProduct4Price);
// console.log(bundleProduct5Price);
// console.log(bundleProduct6Price);
// console.log('------');

      // console.log('mainProductPrice:'+mainProductPrice+'||'+mainProductPriceOrig);
      // console.log('bundleProduct1Price:'+bundleProduct1Price+'||'+bundleProduct1PriceOrig);
      // console.log('bundleProduct2Price:'+bundleProduct2Price+'||'+bundleProduct2PriceOrig);
      // console.log('bundleProduct3Price:'+bundleProduct3Price+'||'+bundleProduct3PriceOrig);
      // console.log('bundleProduct4Price:'+bundleProduct4Price+'||'+bundleProduct4PriceOrig);
      // console.log('bundleProduct5Price:'+bundleProduct5Price+'||'+bundleProduct5PriceOrig);
      // console.log('bundleProduct6Price:'+bundleProduct6Price+'||'+bundleProduct6PriceOrig); 

      //console.log('bundleProductpercentageModifier0:'+percentageModifier0); 


      // console.log('bundlePercentageX:'+bundlePercentage);
      // console.log('percentageModifierX:'+percentageModifier); 
      // console.log('percentageModifier0:'+percentageModifier0); 


      bundleTotalPrice = mainProductPrice + parseInt(bundleProduct1Price) + parseInt(bundleProduct2Price) + parseInt(bundleProduct3Price) + parseInt(bundleProduct4Price) + parseInt(bundleProduct5Price) + parseInt(bundleProduct6Price);
      //console.log('bundleTotalPrice:::', mainProductPrice);
      //console.log('bundleTotalPrice::: 111', bundleProduct1Price);
      //var bundlePriceNoPercentage = bundleTotalPrice
      //bundleTotalPrice = Math.trunc(bundleTotalPrice * percentageModifier);




      var bundlePriceNoPercentage = mainProductPriceOrig + parseInt(bundleProduct1PriceOrig) + parseInt(bundleProduct2PriceOrig) + parseInt(bundleProduct3PriceOrig) + parseInt(bundleProduct4PriceOrig) + parseInt(bundleProduct5PriceOrig) + parseInt(bundleProduct6PriceOrig);
      var bundlePercentageAdj = 0;
      if ($('[data-bundle-percentage]').attr('data-bundle-ajuster') != '') {
        bundlePercentageAdj = parseFloat($('[data-bundle-percentage]').attr('data-bundle-ajuster')) * 100;
      }


      bundleTotalPrice = Math.trunc(bundleTotalPrice);
      console.log('bundleTotalPrice ####', bundleTotalPrice);


      //console.log('bbb bundleTotalPrice:'+bundleTotalPrice);


      //var convertedPrice = Currency.convert(bundleTotalPrice, Shopify.currency.active, defaultCurrency);
      //var convertedPrice = bundleTotalPrice;


      // if (Shopify.currency.active != 'AUD' ) {
      //   convertedPrice = Math.round(bundleTotalPrice * exchRate);
      // }

      //console.log('convertedPrice:'+convertedPrice);

      //var formatedPrice = Shopify.formatMoney(convertedPrice, shop_money);
      var bundlePrice = bundleTotalPrice;
      
      //formatedPrice = formatedPrice+' '+currencyCode;



      

      // console.log('bundleTotalPrice:'+bundleTotalPrice);
      // console.log('bundleTotalPrice percentageModifier0:'+percentageModifier0);


      //var convertedPriceCompare = bundlePriceNoPercentage;
      
      
      //var formatedPriceCompare = Shopify.formatMoney(convertedPriceCompare, Currency.moneyFormats[currentCurrency].money_format);
      //formatedPriceCompare = formatedPriceCompare+' '+currencyCode;
      var bundlePriceCompare = bundlePriceNoPercentage;
      

      //console.log('bbb bundlePriceNoPercentage:'+bundlePriceNoPercentage); 
      //console.log('bbb convertedPriceCompare:'+convertedPriceCompare); 
      var bundleFixedPrice = Math.round(parseFloat($('.product-page-right .prices').attr('data-fixed-bundle-price')) * 100);
      var bundleFixedComparePrice = Math.round(parseFloat($('.product-page-right .prices').attr('data-fixed-bundle-compare-price')) * 100);

      var formatedPrice = customMoney(bundlePrice, false);
      var formatedPriceCompare = customMoney(bundlePriceCompare, false);


      if (bundlePercentage == 0) {
        if (isNaN(bundleFixedPrice) == false) {
          if (isNaN(bundleFixedComparePrice)) {
            // Normal fixed price
            bundlePrice = bundleFixedPrice;
            bundlePriceCompare = 0;
          } else {
            // sale fixed price
            bundlePrice = bundleFixedPrice;
            bundlePriceCompare = bundleFixedComparePrice;
            console.log('bundleTotalPrice: fixxxxxxxed', bundleFixedPrice, bundleFixedComparePrice); 
          }
          formatedPrice = customMoney(bundlePrice, false, 'static');
          formatedPriceCompare = customMoney(bundlePriceCompare, false, 'static');
        }
      }

      

      

      console.log('bundleTotalPrice aa:'+formatedPrice, bundlePercentage); 
      console.log('bundleTotalPrice bb:'+formatedPriceCompare); 
      console.log('bundleTotalPrice bundlePrice cc:'+bundlePrice); 
      console.log('bundleTotalPrice bundlePriceCompare dd:'+bundlePriceCompare); 

      $('.product-page-right .prices').attr('data-actual-price', bundlePrice).attr('data-compare-price', bundlePriceCompare);
      
      if (bundlePrice < bundlePriceCompare) {
        // has discount
        console.log('bundleTotalPrice: discounted'); 
        $('.product-page-right .prices').html('<div class="priceInfo"></div>');        
        bundlePriceHTML = '<span class="actual-price">'+formatedPrice+'</span> <span class="compare-price">'+formatedPriceCompare+'</span>';
        $('.product-page-right .priceInfo').addClass('price-on-sale').html(bundlePriceHTML);
        $('.product-page-right .prices').attr('data-actual-price', bundlePrice);
        $('.product-page-right .prices').attr('data-compare-price', bundlePriceCompare);

        console.log('bundleTotalPrices bundlePrice:'+bundlePrice); 
        console.log('bundleTotalPrices bundlePriceCompare:'+bundlePriceCompare); 

      } else {
        // no discount
        bundlePriceHTML = '<span class="actual-price">'+formatedPrice+'</span>';
        console.log(bundlePriceHTML);
        $('.product-page-right .prices .priceInfo').removeClass('price-on-sale').html(bundlePriceHTML);
      }



      //$('.custom-bundle-price').attr('data-actual-price', (bundleTotalPrice).toFixed(2));
      //$('.custom-bundle-price').attr('data-actual-price', Math.round(bundleTotalPrice));
      // $('.custom-bundle-price').attr('data-actual-price', Math.trunc(bundleTotalPrice));
      // if (moneyDecimal == false) {
      //   $('.custom-bundle-price').attr('data-actual-price', Math.trunc(bundleTotalPrice));
      // }
      // console.log('bundleTotalPrice', bundleTotalPrice);
      // console.log('bundleTotalPrice', Math.trunc(bundleTotalPrice));

      // Check if Custom Bundle Price is existing
      // if ($('.custom-bundle-price').length == 0) {
      //   $('.actual-price').html(formatedPrice);
      // }
      var rt;
      // bundle percentage override
      if (bundlePercentage > 0) {
        clearTimeout(rt);
        rt = setTimeout(function() {
          console.log();
          // $('.actual-price').closest('.priceBox').addClass('price-on-sale')
          // $('.actual-price').html(formatedPrice);
          // $('.custom-bundle-price .compare-price').attr('data-compare-price', formatedPriceCompare).html(formatedPriceCompare);
        }, 10);

        //console.log('actual-price', bundlePercentage);
        //console.log('actual-price', formatedPrice);
        //console.log('actual-price', formatedPriceCompare);
        
      }


      if (Shopify.currency.active != 'AUD' ) {
      }  
        $('[data-market-price]').not('.converted').each(function() {
          var thisAmt = parseInt(Math.round($(this).attr('data-market-price')));
          var thisAmtConv = thisAmt * exchRate;
          if (Shopify.currency.active == 'AUD' ) {
            var moneyCode = Shopify.formatMoney(thisAmtConv, shop_money);
          } else {
            var moneyCode = Shopify.formatMoney(thisAmtConv, shop_money_format);
          } 
          
          $(this).addClass('converted').html(moneyCode);
  
        });
        


      var bundleOOS = false;
      var bundleOOSID = '';
      var bundleOOSTitle = '';
      //console.log(bundleOOS);
      $('.shopify-product-form .bundle-option-wrapper .single-option-selector').each(function() {
          var selVal = $(this).val();
          var thisVariant = $(this).find('option:selected').attr('data-id');
          var thisProdName = $(this).find('option:selected').text().replace(' - (Soldout)', '');
          //console.log($(this).attr('name')+':'+selVal);  
          if (bundleOOS == false && selVal == 'oos') {
              bundleOOS = true;
              bundleOOSID = thisVariant;
              bundleOOSTitle = $.trim(thisProdName);
              return false;
          } else {
            bundleOOSID = '';
            bundleOOSTitle = '';
          }
      });

      $('.product-unavailable p.error').text('');
      if (bundleOOS == true) {
          $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Sold Out').attr('disabled', 'disabled');
      } else {
          $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Add to Cart').removeAttr('disabled', 'disabled');
      }
      //console.log('bundleOOS',bundleOOS);
    };


    var setBundleQty = function() {
      //console.log('setBundleQty xxx');
      if ($('.bundle-option-wrapper .variants').attr('data-qty') != '') {
        var bundleAvailable = true;
        var variantQtyArr = $('.bundle-option-wrapper .variants').attr('data-qty').split(', ');
        var variantQtyTextArr = [];
        var variantQtyQtyArr = [];
        
        $.each( variantQtyArr, function( key, value ) {
          variantQtyTextArr.push(value.split(': ')[0]);
        });

        $.each( variantQtyArr, function( key, value ) {
          variantQtyQtyArr.push(value.split(': ')[1]);
        });

        $('.bundle-option-wrapper .single-option-selector').each(function() {
          var selText = $.trim($(this).find('option:selected').text());
          var qtyValIndex = $.inArray(selText, variantQtyTextArr);

          if (qtyValIndex > -1) {
            $('.bundle-option-wrapper .selector-wrapper').first().find('option:selected').attr('data-qty', variantQtyQtyArr[qtyValIndex]);
            parentQty = parseInt(variantQtyQtyArr[qtyValIndex]);
            bundleUnit = variantQtyQtyArr[qtyValIndex];
            parentInv = $('.bundle-option-wrapper .selector-wrapper').first().find('option:selected').attr('data-inventory');
          }
        });

        if (parentQty <= parentInv) {
          bundleAvailable =  true;
        } else {
          bundleAvailable =  false;
        }

        if (bundleAvailable == false) {
          $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Sold Out').attr('disabled', 'disabled');
        } else {
          $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Add to Cart').removeAttr('disabled', 'disabled');
        }
      }

      /* customiz set qty */
      var bundleAvailable2 = true;
      var customBundleQtyTarget_1 = '';
      var customBundleQtyTarget_2 = '';
      var customBundleQtyTargetTotal_1 = 0;
      var customBundleQtyTargetTotal_2 = 0;

      var customBundleQty_1 = $('.bundle-option-wrapper').attr('data-qty-mod-1');
      if (customBundleQty_1 != '') {
        var customBundleQtyArr_1 = customBundleQty_1.split(';');
        $.each(customBundleQtyArr_1, function(key, value) {
          if (value.indexOf(':') > -1) {
            var qtyArr = $.trim(value);
            var qtySrc = qtyArr.split(':')[0];
            var qtyTarget = qtyArr.split(':')[1].split('=')[0];
            var qtyVal = parseInt(qtyArr.split(':')[1].split('=')[1]);
            customBundleQtyTarget_1 = qtyTarget;
            var mainHandle = $('.product-page-right .bundle-option-wrapper').attr('data-handle');
            if (qtySrc == mainHandle) {
              customBundleQtyTargetTotal_1 += qtyVal;
            }

            $('.shopify-product-form .bundle-option-wrapper select.single-option-selector').each(function() {
                var selectedHandle = $(this).find('option:selected').attr('data-handle');
                if (qtySrc == selectedHandle) {
                    customBundleQtyTargetTotal_1 += qtyVal;
                }
            });
            console.log('customBundleQtyTargetTotal_1', customBundleQtyTargetTotal_1);
          }  
        });
      }
      
      var customBundleQty_2 = $('.bundle-option-wrapper').attr('data-qty-mod-2');
      if (customBundleQty_2 != '') {
        var customBundleQtyArr_2 = customBundleQty_2.split(';');
        $.each(customBundleQtyArr_2, function(key, value) {
          if (value.indexOf(':') > -1) {
            var qtyArr = $.trim(value);
            var qtySrc = qtyArr.split(':')[0];
            var qtyTarget = qtyArr.split(':')[1].split('=')[0];
            var qtyVal = parseInt(qtyArr.split(':')[1].split('=')[1]);
            customBundleQtyTarget_2 = qtyTarget;
            var mainHandle = $('.product-page-right .bundle-option-wrapper').attr('data-handle');
            if (qtySrc == mainHandle) {
              customBundleQtyTargetTotal_2 += qtyVal;
            }
            $('.shopify-product-form .bundle-option-wrapper select.single-option-selector').each(function() {
                var selectedHandle = $(this).find('option:selected').attr('data-handle');
                if (qtySrc == selectedHandle) {
                    customBundleQtyTargetTotal_2 += qtyVal;
                    console.log('customBundleQtyTargetTotal_2', customBundleQtyTargetTotal_2);
                }
            });
          }  
        });
      }  
      

      $('.shopify-product-form .bundle-option-wrapper select.single-option-selector option[data-handle="' + customBundleQtyTarget_1 + '"]').attr('data-qty', customBundleQtyTargetTotal_1);
      $('.shopify-product-form .bundle-option-wrapper select.single-option-selector option[data-handle="' + customBundleQtyTarget_2 + '"]').attr('data-qty', customBundleQtyTargetTotal_2);
      $('.shopify-product-form .bundle-option-wrapper select.single-option-selector').each(function() {
          var inv = parseInt($(this).find('option:selected').attr('data-inventory'));
          var qty = parseInt($(this).find('option:selected').attr('data-qty'));
          if (qty > inv) {
              bundleAvailable2 = false;
          }
      });

      //console.log('bundleAvailable:'+bundleAvailable);
      if (bundleAvailable2 == false) {
        $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Sold Out').attr('disabled', 'disabled');
      } 
      /* customiz set qty */

    };



    // Select Bundle Image by Handle Combination
    var selectImageByHandleCombo = function() {
      var bundleHandle1 = $('#bundledProduct1[data-img-combination="true"]').find('option:selected').attr('data-handle') || '';
      var bundleHandle2 = $('#bundledProduct2[data-img-combination="true"]').find('option:selected').attr('data-handle') || '';
      var bundleHandle3 = $('#bundledProduct3[data-img-combination="true"]').find('option:selected').attr('data-handle') || '';
      var bundleHandle4 = $('#bundledProduct4[data-img-combination="true"]').find('option:selected').attr('data-handle') || '';
      var bundleHandle5 = $('#bundledProduct5[data-img-combination="true"]').find('option:selected').attr('data-handle') || '';
      var bundleHandle6 = $('#bundledProduct6[data-img-combination="true"]').find('option:selected').attr('data-handle') || '';

      var handleCombination = bundleHandle1 + ((bundleHandle2 == '') ? '' : '-') + bundleHandle2 + ((bundleHandle3 == '') ? '' : '-') + bundleHandle3 + ((bundleHandle4 == '') ? '' : '-') + bundleHandle4 + ((bundleHandle5 == '') ? '' : '-') + bundleHandle5 + ((bundleHandle6 == '') ? '' : '-') + bundleHandle6;
      var imageIndex = $('.product-page--thumbs .product-page--thumb:not(.slick-cloned) img[alt="'+handleCombination+'"]').closest('.product-page--thumb').attr('data-slick-index');
          imageCombiSrc = $('.product-page--thumbs .product-page--thumb:not(.slick-cloned) img[alt="'+handleCombination+'"]').attr('src');

      //console.log('handleCombination:'+handleCombination);
      //console.log('imageIndex:'+imageIndex);

      if (imageIndex != undefined) {
        //$('.product-page--thumbs-container').slick('slickGoTo', imageIndex);
      }
      

    };

    if ($('.bundle-option-wrapper').length > 0) {
      
      setBundleQty();
      if (theme.AddOnBundle === undefined && theme.variantBundle == false) {
        totalBundlePriceDisplay();
      } 

      if ($('.single-option-selector[data-img-combination="true"]').length > 0) {
        //selectImageByHandleCombo();
      }

      var checkGreatSticky = setInterval(function(){
        if ($('#great_sticky_bar').length > 0) {
          $('#great_sticky_bar').addClass('bundle-product-header');
          clearInterval(checkGreatSticky);
        }  
      },100);
    }



var origBundlePrice = $('.custom-bundle-price').attr('data-actual-price');
var origBundleComparePrice = $('.custom-bundle-price').attr('data-compare-price');

    
    $('.bundle-option-wrapper').on('focus change', '.single-option-selector', function(){
      if (domReady) {
        var selectedHandle = $(this).find('option:selected').attr('data-handle');
        var imageIndex = parseInt($('.product-page--thumbs .slick-slide:not(.slick-cloned) img[alt="'+selectedHandle+'"]').closest('.slick-slide').attr('data-slick-index'));
        if (isNaN(imageIndex) == false) {
          $('.product-page--thumbs-container').slick('slickGoTo', imageIndex);
        }
      }
    }); 
    
    $('.bundle-option-wrapper').on('change', '.single-option-selector', function(){  
      setBundleQty();
      computeAddOn();
      if (theme.AddOnBundle === undefined && theme.variantBundle == false) {
        totalBundlePriceDisplay();
      } 
      
      if (domReady) {
        var selectedHandle = $(this).find('option:selected').attr('data-handle');
        var imageIndex = $('.product-page--thumbs .product-page--thumb:not(.slick-cloned) img[alt="'+selectedHandle+'"]').closest('.product-page--thumb').attr('data-slick-index');
        console.log(selectedHandle)
        if (imageIndex != undefined) {
          $('.product-page--thumbs-container').slick('slickGoTo', imageIndex);
        }
      }

      // use metafield to modify bundle price
      if (theme.bundleModifierSettings.bundleModifier.length > 0) {
        var modifierFlag = false;
        
        var bundledProductVal1 = '';
        var bundledProductVal2 = '';
        var bundledProductVal3 = '';
        var bundledProductVal4 = '';
        var bundledProductVal5 = '';
        var bundledProductVal6 = '';
        var modifierFlag = false;


        if ($('#bundledProduct1').length > -1) {
          var bundledProductVal1 = $('#bundledProduct1').find('option:selected').attr('data-handle') + ':' + $('#bundledProduct1').find('option:selected').attr('data-id');
        }
        if ($('#bundledProduct2').length > -1) {
          var bundledProductVal2 = $('#bundledProduct2').find('option:selected').attr('data-handle') + ':' + $('#bundledProduct2').find('option:selected').attr('data-id');
        }
        if ($('#bundledProduct3').length > -1) {
          var bundledProductVal3 = $('#bundledProduct3').find('option:selected').attr('data-handle') + ':' + $('#bundledProduct3').find('option:selected').attr('data-id');
        }
        if ($('#bundledProduct4').length > -1) {
          var bundledProductVal4 = $('#bundledProduct4').find('option:selected').attr('data-handle') + ':' + $('#bundledProduct4').find('option:selected').attr('data-id');
        }
        if ($('#bundledProduct5').length > -1) {
          var bundledProductVal5 = $('#bundledProduct5').find('option:selected').attr('data-handle') + ':' + $('#bundledProduct5').find('option:selected').attr('data-id');
        }
        if ($('#bundledProduct6').length > -1) {
          var bundledProductVal6 = $('#bundledProduct6').find('option:selected').attr('data-handle') + ':' + $('#bundledProduct6').find('option:selected').attr('data-id');
        }



        $.each(theme.bundleModifierSettings.bundleModifier, function(key, value) {
            var valArr1 = [];
            var valArr2 = [];
            var valArr3 = [];
            var valArr4 = [];
            var valArr5 = [];
            var valArr6 = [];

            var valArrIndex1 = 0;
            var valArrIndex2 = 0;
            var valArrIndex3 = 0;
            var valArrIndex4 = 0;
            var valArrIndex5 = 0;
            var valArrIndex6 = 0;

            var modifierFound = false;

            // add array
            if (value.mName1 != '') {
              valArr1 = value.mName1.split('|');
            }
            if (value.mName2 != '') {
              valArr2 = value.mName2.split('|');
            }
            if (value.mName3 != '') {
              valArr3 = value.mName3.split('|');
            }
            if (value.mName4 != '') {
              valArr4 = value.mName4.split('|');
            }
            if (value.mName5 != '') {
              valArr5 = value.mName5.split('|');
            }
            if (value.mName6 != '') {
              valArr6 = value.mName6.split('|');
            }

            // check array
            if (valArr1.length > 0) {
              valArrIndex1 = $.inArray(bundledProductVal1, valArr1)
            }
            if (valArr2.length > 0) {
              valArrIndex2 = $.inArray(bundledProductVal2, valArr2)
            }
            if (valArr3.length > 0) {
              valArrIndex3 = $.inArray(bundledProductVal3, valArr3)
            }
            if (valArr4.length > 0) {
              valArrIndex4 = $.inArray(bundledProductVal4, valArr4)
            }
            if (valArr5.length > 0) {
              valArrIndex5 = $.inArray(bundledProductVal5, valArr5)
            }
            if (valArr6.length > 0) {
              valArrIndex6 = $.inArray(bundledProductVal6, valArr6)
            }

            // check if all values match
            if (valArrIndex1 > -1 && valArrIndex2 > -1 && valArrIndex3 > -1 && valArrIndex4 > -1 && valArrIndex5 > -1 && valArrIndex6 > -1) {
                modifierFound = true;
            }
            //console.log('modifierFound', modifierFound);
            console.log('renderPrice modifier #### 000', modifierFound, value.mPrice);  
            if (modifierFound == true && value.mPrice > 0) {
              modifierFlag = true;
              //console.log('modifierFlag = true'); 
              //// console.log(value);
              // console.log('value.mPrice:'+value.mPrice);
              // console.log('value.mComparePrice:'+value.mComparePrice); 
              
              var convertedPrice = Math.trunc(value.mPrice * exchRate);
              //var formatedPrice = Shopify.formatMoney(convertedPrice, shop_money);
              var formatedPrice = customMoney(convertedPrice, false)


              

              //console.log('modifierFlag value.mPrice:'+value.mPrice);
              //console.log('modifierFlag formatedPrice:'+formatedPrice);
              //console.log('modifierFlag convertedPrice:'+convertedPrice);
              //$('.custom-bundle-price .money:not(.compare-price)').html(formatedPrice).attr('data-currency-' + Currency.currentCurrency, formatedPrice).attr('data-price',value.mPrice);
              


              $('.custom-bundle-price .money:not(.compare-price)').html(formatedPrice);
              console.log('renderPrice modifier #### 111');
              //$('.prices .actual-price:not(.compare-price)').html(formatedPrice);


              

              //$('.custom-bundle-price').attr('data-actual-price', (convertedPrice).toFixed(2));
              $('.custom-bundle-price').attr('data-actual-price', Math.trunc(convertedPrice));
              $('.product-page-right .prices').attr('data-actual-price', convertedPrice);
              $('.priceBox ').attr('data-actual-price', Math.trunc(convertedPrice));
              $('.product-page-right .prices').html('<span class="actual-price">'+formatedPrice+'</span>');

              /*
              if (moneyDecimal == false) {
                $('.custom-bundle-price').attr('data-actual-price', Math.trunc(convertedPrice));
                $('.priceBox ').attr('data-actual-price', Math.trunc(convertedPrice));
                $('.product-page-right .prices').attr('data-actual-price', convertedPrice);
              }
              */
              bundlePrice = Math.trunc(convertedPrice);

              //console.log('bundlePrice ####', bundleTotalPrice, bundlePrice, value);  
              //console.log('bundlePrice ####', formatedPrice);  

              // compare price
              console.log('renderPrice modifier #### 000', value, value.mComparePrice, bundleTotalPrice, bundlePrice);
              var bundleTotalDiscounted = false;
              if (bundleTotalPrice > bundlePrice && Math.abs(bundleTotalPrice - bundlePrice) > 5) {
                bundleTotalDiscounted = true;
              }  
              if (value.mComparePrice > 0 || bundleTotalDiscounted) {
                //console.log('ccccccccccccc');
                //console.log('bundleModifier', value.mComparePrice);
                var convertedCPrice = Math.trunc(value.mComparePrice * exchRate);
                var formatedCPrice = customMoney(convertedCPrice, false);

                if (bundleTotalDiscounted) {
                  convertedCPrice = Math.trunc(bundleTotalPrice );
                  formatedCPrice = customMoney(convertedCPrice, false);
                }

                // console.log('cccccccccc');
                // console.log('formatedPrice cccccccccc:'+formatedPrice);

                console.log('renderPrice modifier #### 222', formatedCPrice);
                $('.custom-bundle-price .money.compare-price').html(formatedPrice);
                $('.prices .compare-price .money').html(formatedPrice); 
                $('.prices .compare-price[data-market-price]').html(formatedPrice); 
                $('.product-page-right .prices').attr('data-actual-price', convertedPrice);

                var mPriceHTML = '<div class="price-on-sale custom-bundle-modifier"><span class="actual-price">'+formatedPrice+'</span> <span class="compare-price">'+formatedCPrice+'</span></div>'
                $('.product-page-right .prices').html(mPriceHTML)
              }
            }

        }); // end loop modifier array  


        /*
        if (modifierFlag == false && origBundlePrice != '') {
          var convertedPrice = Currency.convert(origBundlePrice, 'AUD', currentCurrency);
          var formatedPrice = Shopify.formatMoney(convertedPrice, Currency.moneyFormats[currentCurrency].money_format);
          formatedPrice = formatedPrice+' '+currencyCode;
          //console.log('aaaaaaaaaaaaa');
          $('.custom-bundle-price .money:not(.compare-price)').html(formatedPrice).attr('data-currency', Currency.currentCurrency);
          bundlePrice = origBundlePrice;

        }
        if (modifierFlag == false && origBundleComparePrice != '') {
          //console.log('bbbbb');
          var convertedPrice = Currency.convert(origBundleComparePrice, 'AUD', currentCurrency);
          var formatedPrice = Shopify.formatMoney(convertedPrice, Currency.moneyFormats[currentCurrency].money_format);
          formatedPrice = formatedPrice+' '+currencyCode;
          $('.custom-bundle-price .money.compare-price').html(formatedPrice).attr('data-currency', Currency.currentCurrency);
        }
        */
      }
    
      var date = $(this).val();
      var d = new Date();
      var now = d.getTime();
      var upd = localStorage.getItem('updating_date');
      if(!upd) {
        localStorage.setItem('updating_date', now);
      } 
      
      var bThis = $(this);
      var selectedOption = bThis.find(':selected');
      if (bThis.parent().attr('data-series-size-combination') == 'true') {
        var selectedSeries = selectedOption.attr('data-series');
        var selectedSize = selectedOption.attr('data-size-value');
        console.log(selectedSeries);
        console.log(selectedSize);
        var selectSibling = bThis.parent('.selector-wrapper').siblings('[data-series-size-combination="true"]').find('.single-option-selector');
        var selectSiblingVal =  selectSibling.find('option[data-series="'+selectedSeries+'"][data-size-value="'+selectedSize+'"]').attr('value');
       
          
          if(localStorage.getItem('updating_date') == d.getTime()) {
            selectSibling.val(selectSiblingVal).trigger('change');
        }
        setTimeout(function() {
          localStorage.removeItem('updating_date');
        }, 1);      
      }
    });
    
    $('.bundle-option-wrapper .single-option-selector').first().trigger('change');
    console.log('.bundle-option-wrapper .single-option-selector trigger change');

    $('.shopify-product-form .bundle-option-wrapper input.customProp').val('');
    $('.shopify-product-form .bundle-option-wrapper').on('change keypress', 'input.customProp', function(){
      console.log('change keypress');
      var prevSelectTag = $(this).closest('.selector-wrapper').prev('.selector-wrapper').find('select.single-option-selector');
      if ($(this).val() != '') {
        // yes
        var selVal = prevSelectTag.find('option').not('[data-handle*="no-"]').first().attr('value');
        prevSelectTag.val(selVal).trigger('change');
      } else {
        // no 
        var selVal = prevSelectTag.find('[data-handle*="no-"]').attr('value');
        prevSelectTag.val(selVal).trigger('change');
      }
    }); 

    // Check if video is only one
    if ($('.featured-video--body .video--root').length == 1) {
      $('.featured-video--body .video--root').addClass('single-video');
    }
    
  });

  // New Size Selector buttons
  $('.product-page--main-content .with-size-variant .size-button-container a').on('click', function(e){

    e.preventDefault();
    var dataTitle = $(this).attr('data-title');
    $('.product-page--main-content .with-size-variant .single-option-selector').val(dataTitle).change();
    $('.product-page--main-content .with-size-variant .size-button-container a.selected').removeClass('selected');
    $(this).addClass('selected');
  });

  // Image Dots Event
  $(document).on('click', '.product-image-dots-container a', function(e){
    e.preventDefault();

    var target = e.target;
    var dataImageIndex = $(target).attr('data-index');

    if ($(target).hasClass('active') == false) {
      $('.product-image-dots-container a.active').removeClass('active');
      $(target).addClass('active');
      $('.product-page--thumb[data-image-index="' + dataImageIndex + '"]').click();
      $('.product-page--thumbs-container').slick('slickGoTo', dataImageIndex - 1);
    }
  });

  // Image Arrrows Event
  $(document).on('click', '.product-image-dots .image-arrow', function(e){
    e.preventDefault();

    var target = e.target;

    if ($(target).hasClass('arrow-left')) {
      $('.product-page--thumbs-container').slick('slickPrev');
    } else if ($(target).hasClass('arrow-right')) {
      $('.product-page--thumbs-container').slick('slickNext');
    }
  });

  // Thumbnail Event
  $('.product-page--thumb').on('click', function(e){
    var dataDotIndex = $(this).attr('data-image-index');
    $('.product-image-dots-container a.active').removeClass('active');
    $('.product-image-dots-container a[data-index="' + dataDotIndex + '"]').addClass('active');
  });

  $('.product-page--thumbs-container').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.product-page--thumb[data-image-index="' + (currentSlide + 1) + '"]').click();
  });

  // Description Dropdown
  //$('.product-page--description .description-dropdown .dropdown-button-title').removeClass('exp');
  $(document).on('click', '.product-page--description .description-dropdown .dropdown-button-title', function(e){
    e.preventDefault();

    if ($(this).hasClass('active') == false) {
      $('.product-page--description .description-dropdown .dropdown-button-title.active').removeClass('active');
      $('.product-page--description .description-dropdown .rte-content.active').removeClass('active').slideUp(500);
      $(this).addClass('active');
      $(this).parent().find('.rte-content').addClass('active').slideDown(500);
    } else {
      $(this).removeClass('active');
      $(this).parent().find('.rte-content').removeClass('active').slideUp(500);
    }
  });

  // Open First Description Dropdown
  //$('.description-dropdown .dropdown-button-title')[0].click();

  $(document).ready(function() { 
    // check if CBB frequently bought is loaded

    $('.image-dropdown').each(function() {
      var selCont = $(this).closest('.selector-wrapper');
      $(this).clone().addClass('originalSelect').appendTo(selCont); 
      
    });
    $('.bundle-option-wrapper .image-dropdown').not('.originalSelect').ddslick({
    //$('#bundledProduct4').ddslick({  
      onSelected: function(data){
        console.log('ddselect');
        var selectedVal = data.selectedData.value;
        var parentElement = $('.shopify-product-form .bundle-option-wrapper .image-dropdown').parent();
        if (selectFlag = true) {
          parentElement.find('.originalSelect').val(selectedVal).trigger('change');
          console.log('image dropdown trigger change');
          //selectFlag = false;
        }
          
      }
    });
    //$('.image-dropdown').ddslick();


    var cbbFlag = false;
    $('head script').each(function() {
      var xSrc = $(this).attr('src');
      if (xSrc != undefined) {
        if (xSrc.indexOf('codeblackbelt') > 0) {
          cbbFlag = true;
        }  
      }
    });
    // if ($('.cbb-frequently-bought-container').length > 0) {
    //   cbbFlag = true;
    // } else {
    //   cbbFlag = false;
    // }
    //console.log(cbbFlag);
    if (cbbFlag == true) {
      // set call back CBB frequently bought loaded stop after 500 seconds
      var cbbtimesRun = 0;
      var cbbinterval = setInterval(function(){
          cbbtimesRun += 1;
          
          if(cbbtimesRun === 1000){
              clearInterval(cbbinterval);
              //alert('error')
          }
          if (codeblackbelt) {
              //console.log('okayyyy');
              //console.log(codeblackbelt['frequently-bought-togetherLoaded']);
              if (codeblackbelt['frequently-bought-togetherLoaded'] == true && $('.cbb-frequently-bought-selector-list').length > 0) {
                clearInterval(cbbinterval);
                $('.cbb-frequently-bought-selector-list li .imgBox').remove();
                $('.cbb-frequently-bought-selector-list li .overlay').remove();
                $('.cbb-frequently-bought-selector-list li .chckMark').remove();
                $('.cbb-frequently-bought-selector-list li').each(function(index) {
                  var imgSrc = $('.cbb-frequently-bought-products li:eq(' + index + ') .cbb-frequently-bought-product-image').css('background-image').replace('url(', '').replace(')', '').replace(/\"/gi, "").replace('_120x120.', '_480x480.').replace('_240x240.', '_480x480.');
                  var imgSrcHTML = '<div class="chckMark"></div><div class="overlay"></div><div class="imgBox"><img src="' + imgSrc + '" /></div>';
                  console.log('imgSrc');
                  console.log(imgSrc);
                  $(this).find('.cbb-frequently-bought-selector-input').after(imgSrcHTML);
                });
              }
          } else { 
            clearInterval(cbbinterval);
          }
      }, 500); 
    }



  });

}
$(document).ready(function() {
  if (theme.variantBundle) {
    matchVariantBundle('load')
  }
});


!(function($, FrameworkCart, FrameworkOffCanvas){
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  var cartObj;
  var canvasObj;

  var hideInCartUpsellOffer = function(productId) {
    
  };

  // Cart
  FrameworkCart.prototype.updateAllHasItems = function(item_count, force_true) {
    var _this, has_items;
    if (force_true == null) {
      force_true = false;
    }

    if (cartObj == null) {
      cartObj = this;    
    }

    _this = cartObj;
    has_items = false;
    if (item_count > 0 || force_true) {
      has_items = true;
    }
    $(_this.root).attr('data-has-items', has_items);
    return $(_this.other_carts).attr('data-has-items', has_items);
  };

  FrameworkCart.prototype.updateTotals = function() {
    var _this;
    
    if (cartObj == null) {
      cartObj = this;    
    }

    _this = cartObj;

    return $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      var count, total_price;
      var dataItems = data.items;
      total_price = Shopify.formatMoney(data.total_price, theme.money_format);
      count = data.item_count;
      _this.updateAllHasItems(count);
      $(_this.total_price).text(total_price);
      $(_this.total_item_count).text(count);
      _this.updateTotalsComplete(count);
      $('body').removeClass('ajaxLoading');
      return _this.updateCurrencies();
    }).fail(function(jqXHR, textStatus) {
      return console.log('Error - ajax updating totals', $.parseJSON(jqXHR.responseText).description);
    });
  };

  FrameworkCart.prototype.addItem = function(form, callback, item_key, item_quantity, item_properties) {
    $('body').addClass('ajaxLoading');
    var _this;
    _this = this;

    if (item_key != undefined) {
      // Update variant in the cart
      return $.post('/cart/add.js', {
        items: [
          {
            quantity: item_quantity,
            id: item_key,
            properties: item_properties
          }
        ]
      }).always(function(data, textStatus, jqXHR) {
        callback(true);
        //_this.updateAllHasItems(1, true);
        //return _this.updateTotals();
      });
    } else {

      // Add button event for Bundle Products,  will work only if there are bundle products exsited.
      if ($('.template-product').length > 0 && $('.shopify-product-form .bundle-option-wrapper').length > 0) {

          var mainProductId = $('.shopify-product-form .bundle-option-wrapper').attr('data-bundle-product-main');
          var mainHandle = '';

          if (theme.AddOnBundle) {
            mainProductId = $('.product-page-right #variant-listbox').val();
          }  
          if (theme.variantBundle) {
            mainProductId = $('.bundle-option-wrapper [name="variantBundle"]').val();
            mainProductId = $('.product-page-right #variant-listbox').val();
            mainHandle = $('.bundle-option-wrapper [name="mainHandle"]').val();
          }  
          //console.log('mainProductId', mainProductId);

          var bundleName = $('.shopify-product-form .bundle-option-wrapper').attr('data-bundle-name');
          var bundleSize = $('.shopify-product-form .bundle-option-wrapper').attr('data-bundle-name');
          var bundleDiscountPercentage = $('.shopify-product-form .bundle-option-wrapper').attr('data-bundle-discount');
          var bundleItemObject = $('.shopify-product-form .bundle-option-wrapper .selector-wrapper').not('.customProp');
          var itemQuantity = 1;
          var bundleTimeStamp = new Date();
          var itemList = [];
          var itemIDs = [];
          var productProprties = {};
          var productProprties2 = {};
          var propertiesMatchingCover = {};
          var itemPriceHtml = $('.custom-bundle-price .money:not(.compare-price)').html();
          var pProp = {};


          if (theme.template == 'product.matching-cover') {
            //alert(bundleName);
            if ($('#bundledProduct1').length > 0) {
              productProprties = {
                'Bundle Number': Date.parse(bundleTimeStamp)/1000,
                'Bundle Name': bundleName
              };
              if ($('#bundledProduct1 option:selected').text().indexOf(' - ') > -1) {
                propertiesMatchingCover = {
                  'Bundle Number': Date.parse(bundleTimeStamp)/1000,
                  'Bundle Name': bundleName,
                  'Size': $('#bundledProduct1 option:selected').attr('data-size'),
                  'Colour': $('#bundledProduct1 option:selected').attr('data-color')
                };
              }
              
            }

          } else if(theme.template == 'product.quantity-bundle') {
            productProprties = {
              'Bundle Number': Date.parse(bundleTimeStamp)/1000,
              'Bundle Name': bundleName
            };
             productProprties2 = {
              'Bundle Number': Date.parse(bundleTimeStamp)/1000,
              'Bundle Name': bundleName
            };
            
            productProprties['_Image'] = imageCombiSrc;
            productProprties2['_Image'] = imageCombiSrc;
            productProprties['_Product Type'] = 'quantity-bundle';
            productProprties2['_Product Type'] = 'quantity-bundle';
            bundleItemObject.each(function(idx) {
              var selectedLabel = '_'+$(this).find('label').text();
              var selectedText  = $(this).find('.single-option-selector').find(':selected').text();
              productProprties2[selectedLabel] = selectedText;

              if (idx == 0 && parentQty > 0) {
                productProprties2['_Bundle Qty'] = bundleUnit
              } 
            });
          } else {
            productProprties = {
              'Bundle Number': Date.parse(bundleTimeStamp)/1000,
              'Bundle Name': bundleName 
            };  
          }
          
          if ($('.custom-bundle-price').length > 0) {
          }  
            bundlePrice = parseFloat($('.product-page-right .prices').attr('data-actual-price'));
            productProprties['_Bundle Price'] = bundlePrice;


          productProprties['_Bundle Price'] = bundlePrice;
          productProprties['_Bundle ID'] = mainProductId;

          pProp = {
            '_Bundle Price': bundlePrice,
            '_Bundle ID': mainProductId, 
            '_Bundle Handle': mainHandle, 
            'Bundle Number': Date.parse(bundleTimeStamp)/1000,
            'Bundle Name': bundleName 
          };
          if ($('.customProperty').length > 0) {
            pProp['_CustomProperty_'+$('.customProperty').attr('data-label')] = $('.customProperty').val()
          }
          console.log('bundlePrice:'+bundlePrice); 
          //console.log(productProprties2);



          for (var x = 0; x < bundleItemObject.length; x++) {
            var selectedValue = $(bundleItemObject[x]).find('.single-option-selector').find(':selected').val();
            var selectedLabel  = $(bundleItemObject[x]).find('label').text();
            var selectedText  = $(bundleItemObject[x]).find('.single-option-selector').find(':selected').text();       
            var selectedPrice  = parseInt($(bundleItemObject[x]).find('.single-option-selector').find(':selected').attr('data-price'));  

            var customPropLabel = $(bundleItemObject[x]).find('.single-option-selector').find(':selected').attr('data-custom-prop-label');       
            var customPropVal = $(bundleItemObject[x]).find('.single-option-selector').find(':selected').attr('data-custom-prop-value');     

            var xQTY = parseInt($(bundleItemObject[x]).find('.single-option-selector').find(':selected').attr('data-qty')); 
            
            
            if (theme.template == 'product.matching-cover') {
              if (selectedText.toLowerCase().indexOf('matching cover') > -1) {
                var singleItem = { 
                  quantity: xQTY,
                  id: selectedValue,
                  properties: propertiesMatchingCover
                };
              } else {
                var singleItem = {
                  quantity: xQTY,
                  id: selectedValue,
                  properties: productProprties 
                };
              }
            } else if(theme.template == 'product.quantity-bundle') { 
              // bundle
              if (x == 0 && parentQty > 0) {
                
                xQTY = parentQty; 
                var singleItem = {
                  quantity: xQTY,
                  id: selectedValue,
                  properties: productProprties2
                };
              } else {
                var singleItem = {
                  quantity: xQTY,
                  id: selectedValue,
                  properties: productProprties 
                };
              }
            } else {
              var xTXT = $.trim(selectedText).toLowerCase();
              var xTXTNo = xTXT.indexOf('*no');
              if (xTXTNo == -1) {  
                // only add no *No Title selectedText 
                
              
                //if (selectedPrice > 0) {
                // console.log('xTXT:'+xTXT);
                // console.log('xTXTNo:'+xTXTNo);
                // console.log('xQTY:'+xQTY);
                var itemProp = productProprties;

                if (customPropLabel != '' && customPropVal != '' ) {
                  var productProprtiesString = JSON.stringify(productProprties);
                  var itemCustomProp = JSON.parse(productProprtiesString);
                  itemCustomProp['_CustomProperty_'+customPropLabel] = customPropVal;
                  itemProp = itemCustomProp;
                } 
                //console.log(itemProp);
                //console.log('============');

                var singleItem = {
                  quantity: xQTY,
                  id: selectedValue,
                  properties: itemProp 
                };  

              } else {
                //var singleItem = {};
                if (selectedLabel.toLowerCase().indexOf('free') > -1) {
                  var singleItem = {
                    quantity: xQTY,
                    id: selectedValue,
                    properties: productProprties 
                  };  
                } else {
                  var singleItem = {};
                }
              }


            }  
            // itemList.push(singleItem);

            if (itemIDs.indexOf(selectedValue) <= -1) {
              itemList.push(singleItem);
              //itemIDs.push(selectedValue);
            } else {
              itemList.find(x => x.id === selectedValue).quantity += 1; 
            }
            //console.log(selectedLabel);
            //console.log(selectedLabel+':'+selectedText)

            
          } // end for
          //console.log(itemList);

          var bundlePercentage = parseInt($('[data-bundle-percentage]').attr('data-bundle-percentage'));
          if (isNaN(bundlePercentage)) {
            bundlePercentage = 0;
          }
          // bundle percentage is zero add main product
          if (bundlePercentage == 0) {
            
          }
          
          $('.shopify-product-form input.customProp').each(function() {
            pProp['Custom Patch'] = checkPatchProp();  
            var xName = $(this).attr('name');
            pProp[xName] = $(this).val();
          });

          var customBundleProp = $.trim($('.bundle-option-wrapper').attr('data-custom-prop'));
          if (customBundleProp != '') {
           pProp['Type'] = 'Custom Product';  
          }  

          if (theme.variantBundle) {
            // Add main product
            itemList.push({
              quantity: itemQuantity,
              id: mainProductId,
              properties: pProp 
            }); 
          } else {
            // Add main product
            itemList.push({
              quantity: itemQuantity,
              id: $('#variant-listbox').val(),
              properties: pProp 
            }); 
          }


          return $.post('/cart/add.js', {
            items: itemList
          }).always(function(data, textStatus, jqXHR) {
            callback(true);
            loadCart();
          }); 
           
      } else {
        if ($('.free-gift-bundle').length > 0) {

          // free gift crate add
          var bundleTimeStamp = new Date();
          var crateParentProperties = {
            'Bundle Number': Date.parse(bundleTimeStamp)/1000,
            'Bundle Name': $('.product-page--title').first().text(),
            '_Product Type': $('.product-page--cart-form').attr('data-type')
          };

          
          var bundleVal = $('.free-gift-bundle').val();
          var bundleValType = $('.free-gift-bundle option:selected').attr('data-type');
          var itemQuantity = parseInt($('.product-page--cart-form #quantity').val());
          
          var crateChildProperties = {
            'Bundle Number': Date.parse(bundleTimeStamp)/1000,
            'Bundle Name': $('.product-page--title').first().text(),
            '_Product Type': bundleValType
          };

          $('.product-page--cart-form-block .selector-wrapper').each(function() {
            var optLabel = $(this).find('label').text().split(' - ')[0].toLowerCase();
            var optLabel2 = capitalizeFirstLetter(optLabel);
            var optVal = $(this).find('.single-option-selector').val().split(' - ')[0];

            crateParentProperties[optLabel2] = optVal;
            crateChildProperties[optLabel2] = optVal;
          });


          var crateArr = [];
          crateArr.push({
            quantity: itemQuantity,
            id: parseInt(bundleVal), 
            properties: crateChildProperties
          });
          
          crateArr.push({
            quantity: itemQuantity,
            id: parseInt($('#variant-listbox').val()),
            properties: crateParentProperties
          });
          

          //console.log(crateArr); 

          return $.post('/cart/add.js', {
            items: crateArr
          }).always(function(data, textStatus, jqXHR) {
            callback(true);
            var category = $('.boost-pfs-filter-collection-header ').text();
            
            var cItem = {};

              if ($('.product-page--main-content').length > 0) {
                // pdp
                var $item = $('.product-page--cart-form');
                cItem = {
                    Name: $item.attr('data-title'),
                    ProductID: $item.attr('data-id'),
                    Categories: [category],
                    ImageURL: $item.attr('data-img'),
                    URL: $item.attr('data-url'),
                    Brand: 'Stylish Hound',
                    Price: $item.attr('data-price'),
                    CompareAtPrice: $item.attr('data-compare'),
                }
              } 
              _learnq = _learnq || [];
              _learnq.push(['track', 'Added to Cart', cItem]);
            loadCart();             
              //_this.updateAllHasItems(1, true);
              //return _this.updateTotals();
          });


        } else {
          // Normal Add to cart function
          return $.ajax({
          type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: form.serialize()
          }).done(function(data, textStatus, jqXHR) {
            callback(true);
            
            var category = $('.boost-pfs-filter-collection-header ').text();
            var cItem = {};

            if ($('.product-page--main-content').length > 0) {
              // pdp
              var $item = $('.product-page--cart-form');
              cItem = {
                  Name: $item.attr('data-title'),
                  ProductID: $item.attr('data-id'),
                  Categories: [category],
                  ImageURL: $item.attr('data-img'),
                  URL: $item.attr('data-url'),
                  Brand: 'Stylish Hound',
                  Price: $item.attr('data-price'),
                  CompareAtPrice: $item.attr('data-compare'),
              }
            } else {
              // plp
              var $item = form.closest('.product--root');
              cItem = {
                  Name: $item.find('.product--title').text(),
                  ProductID: $item.attr('data-id'),
                  Categories: [category],
                  ImageURL: $item.find('.product--image img').attr('src'),
                  URL: 'https://'+Shopify.shop+$item.find('a').attr('href'),
                  Brand: 'Stylish Hound',
                  Price: $.trim($item.find('.product--price .money').text()),
                  CompareAtPrice: $.trim($item.find('.product--compare-price .money').text())
              }
            }
            _learnq = _learnq || [];
            _learnq.push(['track', 'Added to Cart', cItem]);
            setTimeout(function() {
              loadCart();
            }, 1000);
            
            //_this.updateAllHasItems(1, true);
            //return _this.updateTotals();
          }).fail(function(jqXHR, textStatus) {
            console.log('Error - ajax update quantity', $.parseJSON(jqXHR.responseText).description);
            return callback(false, $.parseJSON(jqXHR.responseText).description);
          });
        }  
          
         


        
      }

    }

  };

  FrameworkCart.prototype.updateQuantity = function(item_key, quantity, time_out, callback) {
    // var _this, ajaxCall;
    // _this = this;
    // ajaxCall = function() {
    //   return _this.ajaxReq.item_key = $.ajax({
    //     type: "POST",
    //     url: "/cart/change.js",
    //     dataType: "json",
    //     data: "quantity=" + quantity + "&id=" + item_key
    //   }).done(function(data, textStatus, jqXHR) {

    //     callback(true);
    //     loadCart();
    //   }).fail(function(jqXHR, textStatus) {
    //     if (jqXHR.responseText) {
    //       console.log('Error - ajax update quantity', $.parseJSON(jqXHR.responseText).description);
    //     }
    //     return callback(false);
    //   });
    // };
    //return _this.updateTimer.item_key = setTimeout(ajaxCall, time_out);
  };

  FrameworkCart.prototype.removeButtonListener = function() {
    var _this, remove_button;
    _this = this;
    remove_button = _this.root.find('.cart--item--remove');

    return remove_button.on('click', function(e) {
      e.preventDefault();

      var target = e.target;
      var item, item_key;
      var qty = 0;
      var data = { updates: {} };

      if ($(target).attr('data-bundle-timestamp')) {
        // Bundle Item Remove
        var bundleTimeStampValue = $(target).attr('data-bundle-timestamp');
        $('[data-bundle-timestamp="' + bundleTimeStampValue + '"]').each(function(btnNum){
          var removeButton = $('[data-bundle-timestamp]')[btnNum];
          item = $('[data-bundle-timestamp]')[btnNum].closest('.cart--item');
          item_key = $(item).attr('data-variant-id');
          data.updates[item_key] = qty;
        });


        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function() {
            loadCart();
          }
        });

        return false;
      } else {
        // Normal Item Remove
        item = $(this).closest('.cart--item');
        item_key = item.data('item-key');
        item.find('input').attr('data-loading', 'true');
        _this.clearRequests(item_key);
        _this.removeItem(item_key);
        return false;
      }

    });
  };

  FrameworkCart.prototype.updateAllHtml = function(update_all_html_done) {
    var _this;
    if (cartObj == null) {
      cartObj = this;    
    }

    _this = cartObj;
    _this.updateHtml(update_all_html_done);
    return _this.other_carts.trigger('updateHtml');
  };

  // Canvas
  FrameworkOffCanvas.prototype.setState = function(state) {
    var _this;
    if (canvasObj == null) {
      canvasObj = this;    
    }

    _this = canvasObj;
    _this.root = $('.off-canvas--viewport')

    _this.state = state;
    return _this.root.attr('data-off-canvas--state', state);
  };

  FrameworkOffCanvas.prototype.fadeInOverlay = function() {
    var _this;
    if (canvasObj == null) {
      canvasObj = this;    
    }

    _this = canvasObj;
    _this.overlay = $('.off-canvas--overlay');
    _this.overlay.show();
    return _this.overlay.velocity({
      opacity: '0.3'
    });
  };

  FrameworkOffCanvas.prototype.toggleListeners = function() {
    var _this;
    if (canvasObj == null) {
      canvasObj = this;    
    }

    _this = canvasObj;
    _this.triggers.on('click', function() {
      if ($(this).data('off-canvas--open') === 'left-sidebar') {
        _this.toggle('left-sidebar');
      } else if ($(this).data('off-canvas--open') === 'right-sidebar') {
        _this.toggle('right-sidebar');
      }
      return false;
    });
    return _this.overlay.add(_this.close).on('click', function() {
      if (_this.state === 'left-open') {
        return _this.toggle('left-sidebar');
      } else if (_this.state === 'right-open') {
        return _this.toggle('right-sidebar');
      }
    });
  };

  FrameworkOffCanvas.prototype.openRight = function() {
    var _this;
    if (canvasObj == null) {
      canvasObj = this;    
    }

    _this = canvasObj;

    _this.viewport = $('.off-canvas--viewport');
    _this.left_sidebar = $('.off-canvas--left-sidebar');
    _this.right_sidebar = $('.off-canvas--right-sidebar');
    _this.main_content = $('.off-canvas--main-content');
    _this.overlay = $('.off-canvas--overlay');
    _this.close = $('.off-canvas--close');
    _this.triggers = $('.off-canvas--open');
    _this.state = 'closed';

    FrameworkOffCanvas.prototype.setState('right-open');
    _this.main_content.css({
      position: 'fixed',
      top: -($(window).scrollTop())
    });
    _this.right_sidebar.velocity({
      translateX: ['-100%', 0]
    }, {
      complete: function() {
        return _this.right_sidebar.css({
          position: 'relative'
        });
      }
    });
    return FrameworkOffCanvas.prototype.fadeInOverlay();
  };

  $(document).ready(function(){
    // Quick Buy Add to cart
    $(document).on('click', '.collection-grid-product-form .add-to-cart input[type="submit"]', function(e){
      e.preventDefault();
      var targetForm = $(e.target).parent().parent().parent();
      theme.classes.FrameworkCart.prototype.addItem($(targetForm), function(){
        //theme.classes.FrameworkCart.prototype.updateAllHtml(function() {});
        //theme.classes.FrameworkOffCanvas.prototype.openRight();
        $('body').addClass('openMenu');
        $('.off-canvas--viewport').attr('data-off-canvas--state','right-open');
        FrameworkOffCanvas.prototype.setState('right-open');
        
        hideInCartUpsellOffer($(targetForm).parent().parent().attr('data-product-id'));
      });
    });

    // Quick Buy Button
    $(document).on('click', '.collection-grid-product-form .quick-buy-button', function(e){
      e.preventDefault();
      var target = e.target;
      var targetParent = $(target).parent();

      if ($(targetParent).hasClass('with-size-variant')) {
        $(target).next('.product-page--cart-form').addClass('reveal');
        $(target).hide();
      } else {
        $(targetParent).find('.add-to-cart input').trigger('click');
      }
    });

    

    

    $(window).on('resize', function(){
      $('.product--title').matchHeight();
      $('.product--details').matchHeight({byRow: false});
    });

    $('.product--title').matchHeight();
    $('.product--details').matchHeight({byRow: false}); 

  });

})(jQuery, theme.classes.FrameworkCart, theme.classes.FrameworkOffCanvas);

$(document).ready(function() {
  if ($('.free-gift-bundle').length > 0) {
    getSizeColor();
    $('body').on('change', '.selector-wrapper select', function() {
      getSizeColor()
    });
  }

  getStickyPosition();
  setTimeout(function(){
    if ($('.shopify-product-form .selector-wrapper').length > 4) {
      $('.product-form-sticky').addClass('long');
    } 
    $('.stky-variant.stky-item').html('');
    $('.product-page-right .product-page--cart-form form > .variants').clone().appendTo('.stky-variant.stky-item');
  }, 600);
  



  $('.product-page--cart-form .selector-wrapper select').each(function() {
    var thisOpt = $(this).attr('data-option');  
    var thisVal = $(this).val();
    $('.product-form-sticky [data-option="'+thisOpt+'"]').val(thisVal);
  });


  setTimeout(function(){
    setStkyPriceATC(); 
  }, 700);  
  
  
  $('.product-page--cart-form').on('change', '.selector-wrapper select', function() {
    var thisOpt = $(this).attr('data-option');  
    var thisVal = $(this).val();
    $('.product-form-sticky [data-option="'+thisOpt+'"]').val(thisVal);
    setStkyPriceATC(); 
    checkVariantDesc('change');

    var prodId = $('.product-page--cart-form').attr('data-id');
    var selectedVariant = $('#variant-listbox option:selected').attr('data-title');
    //$('select.bndlr-select-variant[data-product-id="'+prodId+'"]').val(selectedVariant).trigger('change');

    $('.bndlr-product[data-product-id="'+prodId+'"] .bundlrVariant').removeClass('selected');
    $('.bndlr-product[data-product-id="'+prodId+'"] .bundlrVariant[data-value="'+selectedVariant+'"]').addClass('selected').trigger('click');
    console.log('variant option change');

    getBISStatus()
  });

  $('.product-form-sticky ').on('click', '.stky-atc .add-to-cart input', function() {
    $('.template-product article .quanity-cart-row .add-to-cart input').trigger('click');
  });

  $('.product-form-sticky ').on('change', '.selector-wrapper select', function() {
    var thisOpt = $(this).attr('data-option');  
    var thisVal = $(this).val();




    $('.product-page--cart-form .selector-wrapper  [data-option="'+thisOpt+'"]').val(thisVal).trigger('change');
    $('.product-page--cart-form-block .size-button-container .size-button').removeClass('selected');
    $('.product-page--cart-form-block .size-button-container [data-title="'+thisVal+'"]').addClass('selected');
    if ($(this).hasClass('originalSelect')) {
      //alert('ssssssss');
      var sIndex = $('.originalSelect').find('option:selected').index();
      var sID = $(this).attr('id');
      $('#'+sID).ddslick('select', {index: sIndex });
      //selectFlag = true;
    }
    
  });

  $('.similar-products  .product-page--cart-form').remove();

  afterpayAdjust('ready');
  checkVariantDesc('load');
  getBISStatus();

  $('.sizeChartBox .sizeChartTitle').click(function() {
    $(this).next('.rte-content').slideToggle(500);
  });
});


$('body').on('change', '.single-option-selector', function() {
  afterpayAdjust('change .single-option-selector')
});

window.addEventListener('locationchange', function (e) {
  // afterpay_current_variant.price = parseFloat($('.product-page-right [data-actual-price] .actual-price').text().slice(1)) * 100;
  // $('afterpay-placement').remove();
  // Afterpay.init($) 
});
document.addEventListener('bundler:total_cart_values', function(e) {
  //console.log('Cart Event details', e.detail);
  // The e.details will contain the object with the necessary info. Also, a thing to note here is that the values are always in cents, not in dollars, therefore you have to divide them by 100 to get dollars.
});
document.addEventListener('product:added', function() {
  //console.log('added', e.detail);
});


var apt;
function afterpayAdjust(event) { 
  $('body').addClass('afterpayLoading');
  clearTimeout(apt);
  apt = setTimeout(function() {
    console.log('afterpayAdjust', event);
   if ($('.product-page-right').length > 0) {
      var ap_price =  parseInt($('.product-page-right .prices').attr('data-actual-price'));
      //var ap_price = 900;
      console.log('afterpayAdjust price', ap_price);
      afterpay_current_variant.price = ap_price;
      /*
      if ($('.bundle-option-wrapper').length > 0) {
        afterpay_current_variant.price = parseFloat($('.product-page-right .custom-bundle-price .money:not(".compare-price")').text().replace(',', '').match(/[\d\.]+/)) * 100;
      }
      */
      if( typeof Afterpay != 'undefined') {
        $('afterpay-placement, square-placement').remove();
        $('body').removeClass('afterpayLoading');
         Afterpay.init($) 
      }
     
    }  
            
  }, 600);
  
}

function setStkyPriceATC() {
  $('.stky-price.stky-item').html('');
  $('.stky-atc.stky-item').html('');
  $('.product-page-right .prices').clone().appendTo('.stky-price.stky-item');
  $('.product-page-right .quanity-cart-row').clone().appendTo('.stky-atc.stky-item');
  if ($('.bundle-option-wrapper').length > 0) {
    $('.product-form-sticky').addClass('bundleSticky');  
  }
}




function getSizeColor() {
  var sizeVal = '';
  var colorVal = '';
  $('.selector-wrapper').each(function() {
    var sizeLabel = $(this).find('label').text().toLowerCase().indexOf('size');
    if (sizeLabel > -1) {
      sizeVal = $(this).find('.single-option-selector').val().toUpperCase();
    }
    var colorLabel = $(this).find('label').text().toLowerCase().indexOf('colour');
    if (colorLabel > -1) {
      colorVal = $(this).find('.single-option-selector').val().toUpperCase();
    }
  });
  var bundleVal = $('.free-gift-bundle option[data-color="'+colorVal+'"][data-size="'+sizeVal+'"]').val();
  $('.free-gift-bundle').val(bundleVal);
}
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function getStickyPosition() {
  var elem = $('.product-page-right');
  if (elem.length) {
    var top = $(window).scrollTop(),
        divBottom = (elem.offset().top + elem.outerHeight()) - $('.header-new-main-container').height();
    if (divBottom > top) {
        //console.log('aaaa');
        $('body').removeClass('show-sticky-cart');
        /*
        $('afterpay-placement').remove();
        afterpay_current_variant.price = parseFloat($('.product-page-right [data-actual-price] .actual-price').text().replace(',', '').match(/[\d\.]+/)) * 100;
        if ($('.bundle-option-wrapper').length > 0) {
          afterpay_current_variant.price = parseFloat($('.product-page-right [data-actual-price] .actual-price').text().replace(',', '').match(/[\d\.]+/)) * 100;
        }
        if( typeof Afterpay != 'undefined') {
          //Afterpay.init($) 
        }
        */
    } else {
        //console.log('bbbb');
        $('body').addClass('show-sticky-cart');
    }
  }
}

$(window).on('scroll resize', function() {
  getStickyPosition()
});

document.addEventListener("DOMContentLoaded", function(event) { 
  domReady = true;
});



function checkVariantDesc(event) {
  if ($('.template-product .shopify-product-form #variant-listbox').length > 0) {
    var variantDesc = $('.template-product .shopify-product-form #variant-listbox option:selected').attr('data-desc');
    var variantRecomend = '';
    if ($('.template-product .shopify-product-form #variant-listbox option:selected').attr('data-recomend') != '') {
      variantRecomend = '<div class="reommend">'+$('.template-product .shopify-product-form #variant-listbox option:selected').attr('data-recomend')+'</div>';
    }
    if (variantDesc != '' && variantDesc != undefined) {  
      console.log('load variant desc');
      $('.sizeDescBox').html('<div>'+variantDesc+'</div>'+variantRecomend);
    } else {
      $('.sizeDescBox').html('');
    } 
  }
}


var currentBundleID = '';
var bundles = '';
var bundleDetail;
var discountPercent = 0;
var discountMultiplier = 1;

document.addEventListener('bundler:loaded', function(e) {
  //alert('widget created');
  console.log('widget created');
  // console.log(e);
  // console.log(e.detail.products);
  bundles = window.bndlr.getBundles();
  bundleDetail = e.detail;
  currentBundleID = $('#bundler-target-element [data-bundle]').attr('data-bundle');
  var evenVar = false;
  if(Object.keys(bundleDetail.products).length % 2 == 0) {
    var evenVar = true;
  }

  $('#bundler-target-element [data-bundle]').attr('data-even', evenVar);



  $.each(bundles, function(k, v) {
    if (v.id == currentBundleID) {
        discountPercent = v.percentage_value;
        discountMultiplier = (100 - parseFloat(discountPercent)) * .01;
        return false;
    }
  });

  if ($('#variant-listbox-option-0').length > 0 ) {
    var prodId = $('.product-page--cart-form').attr('data-id');
    var firstVariant = $('#variant-listbox-option-0').val();
    $('.bndlr-product[data-product-id="'+prodId+'"] .bndlr-product-options-container .bndlr-select-variant').val(firstVariant).trigger('change');
    console.log('#variant-listbox-option-0 trigger change');
  }

  $('.bndlr-product[data-available="false"][data-mnm-required="true"]').closest('.bundler-target-element').hide();

  if ($('.bndlr-product[data-available="false"][data-mnm-required="true"]').length == 0) {
    buildBundleWidget(bundleDetail, 'load');
    $('body').addClass('bundleLoaded'); 
  }
  //console.log($('.bndlr-product[data-available="false"][data-mnm-required="true"]').length);


  

  //console.log('bundler:bundle_widget_created')
});


var addTimer;
document.addEventListener('product:added', function() {
  
  clearTimeout(addTimer);
  addTimer = setTimeout(function() {

    // Run code here, resizing has "stopped"
    //alert('added');      
     loadCart('open-cart');  
  }, 300);
});



function buildBundleWidget(bundleDetail, event) {
  var bundleTotal =  0;
  var bundleTotalDiscounted =  0;
  var prodId = $('.product-page--cart-form').attr('data-id');
  var prodSeries = $('.product-page-right').attr('data-series');

  //console.log('buildBundleWidget');
  //console.log(bundleDetail);

  $.each(bundleDetail.products, function(k, v) {
    //console.log('bundleDetail'); 
    //console.log(v);
    //console.log('aa:'+v.title);
    //console.log(v.product_id);
    var activeFlag = false;
    if (prodId == v.product_id && k != 0) {
      $('.bndlr-mnm-available-products').addClass('mutated');
    }

    var itemSel = $('select.bndlr-select-variant[data-product-id="'+v.product_id+'"]');
    var selectedIndex = itemSel.prop('selectedIndex');
    
    if (itemSel.val() === undefined) {
      selectedIndex = 0;
    }
    var priceVal = v.variants[selectedIndex].price;
    bundleTotal += v.variants[selectedIndex].price;

    var ccCode = '';
    if (currencyCode != '') {
      ccCode = ' '+currencyCode;
    }
    var priceHTMLOld = '<span class="bndlr-old-price bndlr-money" data-currency="'+Currency.currentCurrency+'">$'+(priceVal*0.01).toFixed(2)+ccCode+'</span>';
    var priceHTMLDiscounted = '<span class="bndlr-new-price bndlr-money" data-currency="'+Currency.currentCurrency+'">$'+((priceVal*0.01)*discountMultiplier).toFixed(2)+ccCode+'</span>';

    //$('.bndlr-product[data-product-id="'+prodId+'"]').hide().addClass('hide');


    $('.bndlr-product[data-product-id="'+v.product_id+'"]').append('<div class="customInfo"></div>');

    var customVariantDiv = $('.bndlr-product[data-product-id="'+v.product_id+'"] .customVariant');
    var variantSelect = $('.bndlr-product[data-product-id="'+v.product_id+'"] .bndlr-product-options-container .bndlr-select-variant');
    if (customVariantDiv.length == 0) {
      var variantHtml = '';
      var activeClass = '';

      $.each(v.variants, function(index, value) {
        //console.log(value);
        var disableClass = '';
        //console.log('aa:'+activeClass);

        if (value.available == true) {
          if (activeFlag == false) {
            activeClass = 'selected';
            activeFlag = true; 
          } else {
            activeClass = '';
          }
        } else {
          activeClass = '';
          disableClass = 'unavailable';
        }
        
        variantHtml += '<span class="bundlrVariant '+activeClass+' '+disableClass+'" data-value="'+value.title+'">'+value.title+'</span>';
      });   
      //console.log('variantSelect');
      //console.log(variantHtml);

      $('.bndlr-product[data-product-id="'+v.product_id+'"] .customInfo').append('<div class="customVariant">'+variantHtml+'</div>');
    } 

    var customPriceDiv = $('.bndlr-product[data-product-id="'+v.product_id+'"] .customPrice');
    if (customPriceDiv.length == 0) {
      $('.bndlr-product[data-product-id="'+v.product_id+'"] .customInfo').append('<div class="customPrice">'+priceHTMLOld+priceHTMLDiscounted+'</div>');
    }
    $('.bndlr-product[data-product-id="'+v.product_id+'"] .customPrice').html(priceHTMLOld+priceHTMLDiscounted);

    var customCheckBox = $('.bndlr-product.bndlr-mix-and-match[data-product-id="'+v.product_id+'"] .customCB');
    if (customCheckBox.length == 0) {
      $('.bndlr-product.bndlr-mix-and-match[data-product-id="'+v.product_id+'"] .customInfo').append('<div class="customCB"></div>');
    }  

    var prodTitle = $('.bndlr-product[data-product-id="'+v.product_id+'"] .bndlr-product-title').attr('title');
    if (prodSeries != '' && prodTitle.indexOf(prodSeries) > -1) {
      $('.bndlr-product[data-product-id="'+v.product_id+'"] .bndlr-product-title').html('<strong>'+prodSeries+'</strong><span>'+prodTitle.split(prodSeries)[1]+'</span>');
    }
    //prodSeries
  });
  //$('.bndlr-product[data-product-id="'+prodId+'"]').hide().addClass('hide');

  $('.bndlr-product[data-product-id="'+prodId+'"]').addClass('primary');

  //var saveVal = ((bundleTotal - (bundleTotal*discountMultiplier))*0.01).toFixed(2);
  //var subTotal = ((bundleTotal*discountMultiplier)*0.01).toFixed(2);
  var customTotal = $('.customBundlerPrice');

  if (customTotal.length == 0) {
    $('.bndlr-total-price').after('<div class="customBundlerPrice"></div>');
    $('.bndlr-mnm-total-price').after('<div class="customBundlerPrice"></div>');
  }  

  //$('.customBundlerPrice').html('<div class="saveValue">You Save: $'+saveVal+'</div><div class="subtotal">Subtotal: $'+subTotal+'</div>');

  // mix and match auto select
  if (event == 'load') {
    $('#bundler-target-element .bndlr-mnm-available-products .bndlr-add-to-bundle').not('.bndlr-hidden').trigger('click');
    $('.bndlr-product.bndlr-mix-and-match').addClass('mm-added');
    
    $('.bndlr-mnm-available-products .bndlr-product-qn-container').matchHeight({byRow: true});
    $('.bndlr-mnm-available-products .customInfo').matchHeight({byRow: true});
    /*
    $('.bndlr-mnm-available-products').slick({
        arrows: false,
        dots: true,
        infinite: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        //centerMode: true, 
        //fade: true,
        responsive: [ 
          {
            breakpoint: 992, 
            settings: {
              slidesToShow: 3 
            }
          },  
          {
            breakpoint: 768, 
            settings: {
              slidesToShow: 2 
            }
          },
          {
            breakpoint: 480, 
            settings: {
              slidesToShow: 1 
            }
          }    
        ]
      });
      $('.bndlr-mnm-available-products').slick('slickFilter',':not(".hide")');
      $('.bndlr-mnm-available-products').slick('slickFilter',':not([data-available="false"])');
      */

  }

  countSelectedATC();
  
  if (event == 'load') {
    console.log('buildBundleWidget load');
  } else {
    console.log('buildBundleWidget');
  }

}

$('body').on('change', '.bndlr-select-variant[name="variant_id"]', function() {
  //console.log('event change: bndlr-select-variant')
  buildBundleWidget(bundleDetail, 'change')
});

// bunler auto change
$('body').on('click', '.bundlrVariant', function() {
  var parentGrid = $(this).closest('.bndlr-product');
  var parentID = parentGrid.attr('data-product-id');
  var variantSelect = parentGrid.find('.bndlr-product-options-container .bndlr-select-variant');
  var variantValue = $(this).attr('data-value');  
  variantSelect.val(variantValue).trigger('change');

  // change hidden select option
  parentGrid.find('.bundlrVariant').removeClass('selected');
  $(this).addClass('selected');

  // change main variant
  var variantMainSelect = parentGrid.find('select[name="variant_id"]');
  var variantMainSelectVal = variantMainSelect.find('option[data-option0="'+variantValue+'"]').val();
  variantMainSelect.val(variantMainSelectVal).trigger('change');

  // auto remove
  $('img.id_'+parentID).closest('.bndlr-mix-and-match').find('.bndlr-close').trigger('click');

  // auto add 
  $('.bndlr-product.bndlr-mix-and-match[data-product-id="'+parentID+'"]').addClass('mm-added').find('.bndlr-add-to-bundle').not('.bndlr-hidden').trigger('click');

  countSelectedATC()
  //console.log('click:'+parentID)
});

// add checked item
$('body').on('click', '.customCB', function() {
  var pID = $(this).closest('.bndlr-product.bndlr-mix-and-match').attr('data-product-id');
  var pGrid = $(this).closest('.bndlr-product.bndlr-mix-and-match');
  var pSelectedGrid = $('.bndlr-mnm-selected-products .bndlr-product-image.id_'+pID).closest('.bndlr-product');

  if (pGrid.hasClass('mm-added') == true) {
    pGrid.removeClass('mm-added');
    pSelectedGrid.find('.bndlr-close').trigger('click');
  } else  {
    // add checked items
    if (pGrid.find('.bundlrVariant.selected').length > 0) {
      pGrid.find('.bundlrVariant.selected').trigger('click');
    } else {
      pGrid.find('.bndlr-add-to-bundle').not('.bndlr-hidden').trigger('click');
      pGrid.addClass('mm-added');
    }
  }

  countSelectedATC()
});  
$('body').on('click', '.showMore', function() {
  $(this).closest('.otherOptionBox').toggleClass('exp');
  if ($(this).closest('.otherOptionBox').hasClass('exp')) {
    $(this).html('Show Less -');
  } else {
    $(this).html('Show Less +');
  }
});  

function countSelectedATC() {
  // adjust price 
  var ccCode = '';
    if (currencyCode != '') {
      ccCode = ' '+currencyCode
    }

  var subTotalTxt = $('.bndlr-mnm-total-price .bndlr-new-price').text()+ccCode;
  var oldPriceVal = $('.bndlr-mnm-total-price .bndlr-old-price ').attr('data-currentprice');
  var newPriceVal = $('.bndlr-mnm-total-price .bndlr-new-price').attr('data-currentprice');


  if (oldPriceVal != undefined ) {
    var saveVal = parseInt(oldPriceVal) - parseInt(newPriceVal);
    var saveValTxt = '$'+(saveVal / 100).toFixed(2)+ccCode;
    $('.customBundlerPrice').html('<div class="saveValue">You Save: <span class="money" data-currency="'+Currency.currentCurrency+'">'+saveValTxt+'</span></div><div class="subtotal">Subtotal: <span class="money" data-currency="'+Currency.currentCurrency+'">'+subTotalTxt+'</span></div>');
  } else {
    $('.customBundlerPrice').html('<div class="subtotal">Subtotal: <span class="money" data-currency="'+Currency.currentCurrency+'">'+subTotalTxt+'</span></div>');
  }
  // adjust atc
  var selectedCount = $('.bndlr-mnm-selected-products .bndlr-product.bndlr-mix-and-match').length;
  if (selectedCount > 1) {
    $('.bndlr-mnm-add-to-cart-wrapper .bndlr-add-bundle-to-cart').text('Add '+selectedCount+' Items');
    $('.customBundlerPrice').show();
  } else {
    $('.bndlr-mnm-add-to-cart-wrapper .bndlr-add-bundle-to-cart').text('Add '+selectedCount+' Item');
    $('.customBundlerPrice').hide(); 
  }
}

$(document).ready(function() {
  adjustSize();
  $('body').attr('data-market-currency', Shopify.currency.active);
});

function adjustSize() {
  if ( $('.product-page--main-content .size-button-container .size-button').length > 0) {
    var sizeEntryHt = $('.product-page--main-content .size-button-container .size-button').height();
    var sizeBoxHt = $('.product-page--main-content .size-button-container .sizeList').height();
    var sizeEntryHtTreshold = (sizeEntryHt * 2) - 4;

    if (sizeBoxHt > sizeEntryHtTreshold) {
      var maxWidth = Math.max.apply( null, $('.product-page--main-content .size-button-container .size-button').map( function () {
        return $( this ).outerWidth( true );
      }).get() );
      $('.product-page--main-content .size-button-container .size-button').width(maxWidth);
    } else {
      $('.product-page--main-content .size-button-container .size-button').width('auto');
    }
  } 
}

function checkPatchProp() {
  var customBundleProp = $.trim($('.bundle-option-wrapper').attr('data-custom-prop'));
  var customBundlePropVal = '';
  var customPropInput = $('input.customProp').val();
  if (customPropInput != undefined && customPropInput != '') {
      if (customBundleProp != undefined && customBundleProp != '') {
          var customBundlePropArr = customBundleProp.split(';');
          var bundleTxt1 = $.trim($('#bundledProduct1').find('option:selected').text());
          var bundleTxt2 = $.trim($('#bundledProduct2').find('option:selected').text());
          var bundleTxt3 = $.trim($('#bundledProduct3').find('option:selected').text());
          var bundleTxt4 = $.trim($('#bundledProduct4').find('option:selected').text());
          var bundleTxt5 = $.trim($('#bundledProduct5').find('option:selected').text());
          var bundleTxt6 = $.trim($('#bundledProduct6').find('option:selected').text());

          var variantText1 = $('.product-page-right .product-form__input--pill input:checked').val();
          var variantText1Val = '*****';
          if (variantText1 != '' || variantText1 != undefined) {
            variantText1Val = ' - ' + variantText1;
          }

          var customBundlePropArr2 = $.grep(customBundlePropArr, function(array) {
              return array.length > 0;
          });

          $.each(customBundlePropArr2, function(key, value) {
              var propKey = $.trim(value).split(' | ')[0];
              var propKeyName = propKey.split(' - ')[0];
              var propKeyVal = ' - ' + propKey.split(' - ')[1];
              var propVal = $.trim(value).split(' | ')[1] + ', ';
              var variantTextVal = '';
              var pTitle = $('.product-page--title').attr('data-title');
              if (pTitle.indexOf(propKeyName) > -1) {
                variantTextVal = propKeyName + variantText1Val
              }
              if (propVal != 'undefined') {
                  if (variantTextVal.indexOf(propKey) > -1) {
                       customBundlePropVal = customBundlePropVal + propVal;
                  }
                  if (bundleTxt1.indexOf(propKey) > -1) {
                      customBundlePropVal = customBundlePropVal + propVal;
                  }
                  if (bundleTxt2.indexOf(propKey) > -1) {
                      customBundlePropVal = customBundlePropVal + propVal;
                  }
                  if (bundleTxt3.indexOf(propKey) > -1) {
                      customBundlePropVal = customBundlePropVal + propVal;
                  }
                  if (bundleTxt4.indexOf(propKey) > -1) {
                      customBundlePropVal = customBundlePropVal + propVal;
                  }
                  if (bundleTxt5.indexOf(propKey) > -1) {
                      customBundlePropVal = customBundlePropVal + propVal;
                  }
                  if (bundleTxt6.indexOf(propKey) > -1) {
                      customBundlePropVal = customBundlePropVal + propVal;
                  }
              }
          });
      } 
  }     
  return customBundlePropVal;
}



var presizeTimer;

$(window).on('resize', function(e) {

  clearTimeout(presizeTimer);
  presizeTimer = setTimeout(function() {

    adjustSize()
            
  }, 600);

});


$('body').on('click', '.bundle-size-button', function() {
  var xVal = $(this).attr('data-value');
  var xSel = $(this).closest('.selector-wrapper').find('select.single-option-selector ');
  xSel.val(xVal).trigger('change');
  console.log(xVal);
  return false;
});

var variantTimer;
$('body').on('change', '.variantSelectBox .select__select', function() {
    console.log('variantSelectBox');
    var thisIndex = $(this).attr('data-index');
    var thisVal = $(this).val();
    if (thisIndex == 0) {
      $('#variant-listbox-option-0').val(thisVal).trigger('change');
    }    
    if (thisIndex == 1) {
      $('#variant-listbox-option-1').val(thisVal).trigger('change');
    }  
    if (thisIndex == 2) {
      $('#variant-listbox-option-2').val(thisVal).trigger('change');
    }   
    clearTimeout(variantTimer);
    variantTimer = setTimeout(function() {
      renderPrice()
    }, 100);
});
$(document).ready(function() {
  //loop shopify variant when bundle is enabled
  /*
  var shopifyBundleSize = $('.product-page-right.shopifyBundle').length;
  if (shopifyBundleSize > 0) {
    var prodURL = $('.product-page--cart-form').attr('data-url');
    var loadVariantURL = prodURL+'?view=options';
    $.ajax({
      url: loadVariantURL,
      type: 'GET',
      success: function(data) {
        $('.customVariantBox').html(data);
        $('.product-page-right.shopifyBundle .selector-wrapper').each(function(index) {
          var thisSelectVal = $(this).find('.single-option-selector').val();

          $('.product-page-right.shopifyBundle #Option-product-'+index).val(thisSelectVal);
          $('.product-page-right.shopifyBundle #Option--'+index).val(thisSelectVal)
        });
        $('.customVariantBox').addClass('loaded');
        renderPrice()
      },
      error: function(xhr, status, error) {
         $('.customVariantBox').html("Sorry but there was an error: " + xhr.status + " " + xhr.statusText);
         $('.customVariantBox').addClass('loaded');
      }
    });
  } 
  */
  if (theme.newVariantPicker) {
  }  
    setTimeout(function(){
      getSelectedVariant(false, 'load');
    }, 800);
  
  
  var customVariantBoxCount = $('.customVariantBox').length;
  if (customVariantBoxCount > -1) {
    $('body').on('change', '.customVariantBox input[type="radio"], .customVariantBox select', function() {
      var thisVal = $(this).val();
      var thisOption = $.trim($(this).closest('.product-form__input').find('.form__label').text().toLowerCase());
      console.log('thisOption', thisOption);
      var colorFlag = false;
      
      if (thisOption.indexOf('colour') > -1 || thisOption.indexOf('color') > -1) {
        colorFlag = true;
        console.log('thisOption swatch', colorFlag);
        
      }
      getSelectedVariant(colorFlag, 'change'); 
      getBISStatus();
      setStkyPriceATC(); 
    });
    $('.product-form-sticky').off('change', '.selector-wrapper select');
    $('.product-form-sticky').on('change', '.single-option-selector', function() {
      
      var currentIndex = parseInt($(this).attr('data-option').replace('option', ''));
      var thisVal = $(this).val();

      console.log('sticky change', currentIndex, thisVal);
      $('.customVariantBox input[value="'+thisVal+'"][data-index="'+currentIndex+'"]').prop('checked', true).trigger('change');
      setStkyPriceATC(); 
    });
  }

}); 

function setColorID() {
  //console.log('setColorID');
  var currentColor = $('.product-form__input--swatch [data-selected-value]').text();
  $('.customFieldset .iconList li').each(function() {
    var dataOpts = $(this).attr('data-opts');
    var pairs = dataOpts.replace(/,\s*$/, '').split(', ');
    //console.log(pairs);
    var colorId = null;
    $.each(pairs, function(index, pair) {
        pair = pair.trim(); // Remove any extra spaces
        if (pair.startsWith(currentColor)) {
            // Step 4: Extract the ID by splitting on the colon
            colorId = pair.split(':')[1];
            return false; // Exit the loop once we find "Chrome"
        }
    });
    $(this).attr('data-color-id', colorId);
    if ($(this).find('.pdpAjaxLink').length > 0) {
      var colorHref = $(this).find('.pdpAjaxLink').attr('href').split('?')[0];
      colorHref = colorHref+'?variant='+colorId;
      $(this).find('.pdpAjaxLink').attr('href', colorHref);
      //console.log('setColorID color ID:', colorId, currentColor);
    }
    
  });
}

function getSelectedVariant(colorFlag, event) {
  console.log('getSelectedVariant', $('#variant-listbox').val());
  var selectedVariant = '';

  $('.customVariantBox input[type="radio"]:checked, .customVariantBox select').each(function(index) {
    var thisVal = $(this).val();
    
    console.log('variant-option'+index, $('.stky-variant #variant-listbox-option-'+index).length);
    
    $('.stky-variant #variant-listbox-option-'+index).val(thisVal);
    setStkyPriceATC();
    
    if (index == 0) {
      selectedVariant = thisVal;
      console.log('selectedVariant', index, selectedVariant);
    } else if (index == 1) {
      selectedVariant = selectedVariant+' / '+thisVal;
      console.log('selectedVariant', index, selectedVariant);
    } else {
      selectedVariant = selectedVariant+' / '+thisVal;
      console.log('selectedVariant', index, selectedVariant);
    } 
  });


  var variantName = selectedVariant; 

  var matchingVariant = findVariantByName(variantName);

  console.log('selectedVariant matchingVariant', selectedVariant, matchingVariant);
 
  if (matchingVariant) {
    var avail = matchingVariant.available
    var price = matchingVariant.price;
    var comparePrice = matchingVariant.compare_at_price;
    if (theme.variantBundle) {
      price = 10000;
    }

    var variantImg = '';
    if (matchingVariant.featured_image != undefined) {
      variantImg = matchingVariant.featured_image.src;
    }
    
    

    if (theme.newVariantPicker) {

    } else {
      if (matchingVariant.featured_image != undefined) {
        selectedVariantImageSlider(variantImg);
      }
    }
    
    
    setVariantParam(matchingVariant.id);

    var variantCount = $('.product-page--cart-form #variant-listbox option').length;

    if (variantCount > 1) {
      $('.product-page--cart-form #variant-listbox').val(matchingVariant.id).trigger('change');
      console.log('.product-page--cart-form #variant-listbox matchingVariant trigger change');
      //console.log('price', Shopify.formatMoney(price, shop_money));
      //console.log('compare price', Shopify.formatMoney(comparePrice, shop_money));

      var vID = matchingVariant.id;
      var priceHTML = $('.variantAttr [data-id="'+vID+'"] .priceHTML').html();
      console.log('vvv', vID, priceHTML);

      //console.log('renderPrice matchingVariant', vID, $('.variantAttr [data-id="'+vID+'"]').html());
      $('.product-page-right .prices').html(priceHTML); 
      console.log('vvv', vID, priceHTML);
    
      $('.product-page-right .prices').attr('data-actual-price', $('.product-page-right .priceInfo').attr('data-price'));
      $('.product-page-right .prices').attr('data-compare-price', $('.product-page-right .priceInfo').attr('data-compare'));

      console.log('bundleTotalPrices matching', variantName, priceHTML);
      //computeAddOn();
    } 


    //console.log("Variant", 'avail:'+avail, matchingVariant, variantImg);

    console.log('avail', avail);
    $('.product-form-sticky').attr('data-availability', avail);
    $('.product-page-right .product-page--cart-form-block').attr('data-availability', avail);
    if (avail) {
      $('.product-page-right .quanity-cart-row').css('display', 'flex');
    } else {
      $('.product-page-right .quanity-cart-row').css('display', 'none');
    }
    if (theme.LinkProduct || theme.newVariantPicker) {
      var prodURL = $('.product-page--cart-form').attr('data-url');
      var matchingID = matchingVariant.id;
      var loadVariantURL = prodURL+'?view=options&variant='+matchingID;
      loadVariantHTML(loadVariantURL);
      if (event == 'change' && colorFlag == true) {
        var loadColorURL = prodURL+'?view=image&variant='+matchingID;
        loadGallery(loadColorURL);   
      }
    }  
  } 
}
function loadGallery(loadColorURL) {
  console.log('loadGallery');
  var elem = $('.product-page-left');
  elem.addClass('ajaxLoad');
  elem.removeClass('loaded');
  loadColorURL = 
  $.ajax({
    url: loadColorURL,
    type: 'GET',
    success: function(data) {
        //elem.html(data).addClass('loaded');
        elem.html(data).addClass('loaded');
        gallerySlider()

        
        
    },
    error: function(xhr, status, error) {
       elem.html("Sorry but there was an error: " + xhr.status + " " + xhr.statusText);
       elem.addClass('loaded');
    }
  });  
}
function setVariantParam(variantID) {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);
  params.set('variant', variantID);
  url.search = params.toString();
  window.history.replaceState({}, '', url);  
}
function selectedVariantImageSlider(variantImage) {
  var variantImg = variantImage;
  var targetIndex = $('.product-page--thumbs-container .product-page--thumb[data-src="' + variantImg + '"]').closest('.slick-slide').attr('data-slick-index');
  //console.log('targetIndex', targetIndex);
  $('.product-page--thumbs-container').slick('slickGoTo', targetIndex);
}

function findVariantByName(variantName) {
  var variant = product_json.variants.find(function(v) {
    return v.title.toLowerCase() === variantName.toLowerCase();
  });
  return variant;
}
function loadVariantHTML(loadVariantURL) {  
  console.log('loadVariantHTML');  
  //$('.customVariantBox').removeClass('loaded');
  $.ajax({
    url: loadVariantURL,
    type: 'GET',
    success: function(data) {
      $('.customVariantBox').html(data);
      /*
      $('.product-page-right.newVariantPicker .selector-wrapper').each(function(index) {
        var thisSelectVal = $(this).find('.single-option-selector').val();

        $('.product-page-right.newVariantPicker #Option-product-'+index).val(thisSelectVal);
        $('.product-page-right.newVariantPicker #Option--'+index).val(thisSelectVal)
      });
      */
      $('.customVariantBox').addClass('loaded');
      if (theme.LinkProduct) {
        setColorID();
      }
      if (theme.variantBundle) {
        matchVariantBundle('load')
      }
      computeAddOn();
      checkVariantDesc('loadVariantHTML')
      afterpayAdjust('loadVariantHTML');
      if ($('.customVariantPicker').length > 0) {
          var dataLabel = $('.customVariantPicker').attr('data-label');
          $('.customVariantBox .product-form__input--dropdown[data-label="'+dataLabel+'"]').hide();
      }


      //renderPrice()
    },
    error: function(xhr, status, error) {
       $('.customVariantBox').html("Sorry but there was an error: " + xhr.status + " " + xhr.statusText);
       $('.customVariantBox').addClass('loaded');
    }
  });
}  



function renderPrice() {
  var variantId = getQueryParam('variant');
  var priceHTML = $('.variantAttr li').first().find('.priceHTML').html();
  console.log('renderPrice', variantId);
  if (variantId) {
    priceHTML = $('.variantAttr li[data-id="'+variantId+'"] .priceHTML').html();
  }
  console.log('renderPrice', priceHTML);
  $('.product-page-right .prices').html(priceHTML);
  /*
  if ($('.product-page-right.shopifyBundle .priceBox .compare-price').length > 0) {
    $('.product-page-right.shopifyBundle > .prices').addClass('price-on-sale');
  } else {
    $('.product-page-right.shopifyBundle > .prices').removeClass('price-on-sale');
  }  
  */
  $('.product-page-right > .prices').addClass('loaded');
}
function getQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}


$('body').on('click', '.pdpAjaxLink', function() {
  var ajaxURL = $(this).attr('href');
  var colorID = $(this).closest('[data-color-id]').attr('data-color-id');
  var colorID = $(this).closest('[data-color-id]').attr('data-color-id');
  loadProductContent(ajaxURL, currentGalleryIndex, colorID);
  return false;     
});


function loadProductContent(ajaxURL, currentGalleryIndex, colorID) {
  var loadURL = ajaxURL+'?view=content';
  
  if (ajaxURL.indexOf('?') > -1) {
    loadURL = ajaxURL+'&view=content';
  }
  if (colorID != undefined && colorID != '') {
    loadURL = ajaxURL+'&view=content';
  }
  window.history.pushState({ path: ajaxURL }, '', ajaxURL);
  if (theme.LinkProduct) {
    $('.productMainContent').addClass('ajaxLoad');
    $('.productMainContent').removeClass('loaded');
  }
  $('.productMainContent').load(loadURL, function(response, status, xhr) {
    
    var prodTitle = $('.product-page--title').attr('data-title');
    //$('.breadcrumbs li').last().text(prodTitle);
    product_json = JSON.parse($('.dataVariables').html());
    product_variant_size = parseInt($('.dataVariables').attr('product_variant_size'));
    
    if (theme.LinkProduct) {
      checkVariantDesc('click');
      $('.productMainContent').addClass('loaded');
      gallerySlider();
      setColorID();
      afterpayAdjust('loadProductContent');
      getBISStatus()
    }  
  });

  
}

function gallerySlider() {
  var slideToShow = parseInt($('.product-page--images-container').attr('data-image-layout'));
  if ($('.main-product-slider').hasClass('slick-initialized')) {
    $('.main-product-slider').slick('unslick');
  }
  if ($('.product-page--thumbs-container').hasClass('slick-initialized')) {
    $('.product-page--thumbs-container').slick('unslick');
  }
  $('.product-page--thumbs-container').slick({
    arrows: true,
    infinite: true,
    focusOnSelect: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    //centerMode: true,
    asNavFor: '.main-product-slider',
    responsive: [ 
      {
        breakpoint: 1281, 
        settings: {
          slidesToShow: 5 
        }
      }, 
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 4 
        }
      }  
    ]
  }); 
  $('.main-product-slider').slick({
    arrows: true,
    dots: true,
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: slideToShow,
    slidesToScroll: 1,
    //fade: true,
    lazyLoad: 'ondemand',
    asNavFor: '.product-page--thumbs-container',
    responsive: [ 
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 1 
        }
      }  
    ]
  });
  $.fancybox.destroy();
  $('[data-fancybox="images"]').fancybox({
    loop: false, 
    hash: false, 
    selector: '[data-fancybox="images"]:not(.slick-cloned a)',
    toolbar: "auto",
    buttons: [
      "zoom",
      "close"
    ],
    infobar: false,
      afterLoad : function(instance, current) {
          var pixelRatio = window.devicePixelRatio || 1;

          if ( pixelRatio > 1.5 ) {
              current.width  = current.width  / pixelRatio;
              current.height = current.height / pixelRatio;
          }
      }
  });
}



function customKlaviyoBIS(variantID, email) {
    var payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": email
              }
            }
          },
          "channels": ["EMAIL"]
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::"+variantID
            }
          }
        }
      }
    };
    console.log('customKlaviyoBIS', variantID, payload);
    // Perform the AJAX request
    var requestURL = $('#custom-back-in-stock-form').attr('data-request');
    $.ajax({
      url: requestURL,
      type: 'POST',
      contentType: 'application/json',
      headers: {
        "revision": "2024-06-15"
      },
      data: JSON.stringify(payload),
      success: function(response) {
        console.log(response);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log('Error:', textStatus, errorThrown);
        $('#custom-back-in-stock-form').attr('data-status', 'error');
        $('#custom-back-in-stock-form .message').text(errorThrown);
      },
      complete: function(jqXHR, textStatus) {
        console.log("Status Code:", jqXHR.status);
        if (jqXHR.status == 202) {
          $('#custom-back-in-stock-form').attr('data-status', 'success');
          $('#custom-back-in-stock-form .message').text("You're in! We'll let you know when it's back.");
        }
      }  
    });
}    

function getBISStatus() {
  if (theme.BundleProduct === undefined) {
    var stockFlag = true; 
    if ($('#variant-listbox option:selected').attr('disabled') === undefined) {
      stockFlag = true;
    } else {
      stockFlag = false;  
      $('#custom-back-in-stock-form button').removeAttr('disabled');
    }
    if (parseInt($('#variant-listbox option:selected').attr('data-inventory-quantity')) > 0) {
      stockFlag = true;
    } else {
      stockFlag = false;  
      $('#custom-back-in-stock-form button').removeAttr('disabled');
    }
    $('#custom-back-in-stock-form').attr('data-status', '');
    console.log('avail stockFlag:', stockFlag);
    $('.product-page-right .product-page--cart-form-block').attr('data-availability', stockFlag);
    $('#custom-back-in-stock-form').attr('data-id', $('#variant-listbox').val())
    //console.log('getBISStatus', stockFlag);
  }  
}    
$('body').on('submit', '#custom-back-in-stock-form', function(event) {
   var vID = $('#custom-back-in-stock-form').attr('data-id');
   if (vID === undefined) {
      vID = $('.product-page-right  #variant-listbox option').first().val();
   }
   var xEmail = $('#custom-back-in-stock-form [name="email"]').val();
   if (xEmail != '') {
      $('#custom-back-in-stock-form').attr('data-status', 'loading'); 
   }
   customKlaviyoBIS(vID, xEmail)
   event.preventDefault();
}); 



function computeAddOn() {
  if (theme.AddOnBundle) {
    console.log('computeAddOn');
    var finalPrice = parseInt($('.product-page-right .prices .priceInfo').attr('data-price'));
    var finalPriceCompare = parseInt($('.product-page-right .prices .priceInfo').attr('data-compare'));

    console.log('finalPrice', finalPrice, 'finalPriceCompare', finalPriceCompare);

    var addOnPrice = 0;
    var addOnPriceCompare = 0;


    var discountPercent = parseInt($('.bundle-option-wrapper').attr('data-bundle-percentage'));
    var bundlrPercentageModifier = 1;
    if (discountPercent > 0) {
      bundlrPercentageModifier = (100 - discountPercent) / 100;
    }
    //console.log('bundlrPercentageModifier', bundlrPercentageModifier);
    var bundlePriceHTML = '';

    $('.product-page-right .bundle-option-wrapper .selector-wrapper').not('.customProp').each(function() {
      var bLabel = $(this).children('label').text();
      var bItemQTy = parseInt($(this).find('option:selected').attr('data-qty'));
      var bPrice = parseInt($(this).find('option:selected').attr('data-price'));
      var bCompare = bPrice;
      if (bundlrPercentageModifier < 1) {
        bPrice = Math.round(bPrice * bundlrPercentageModifier);
      }
      bPrice = bPrice * bItemQTy
      bCompare = bCompare * bItemQTy
      console.log(bLabel, 'bPrice', 'x'+bItemQTy, bPrice, 'bCompare', bCompare);
      if (bPrice > 0) {
        addOnPrice += bPrice
      }
      if (bCompare > 0) {
        addOnPriceCompare += bCompare
      }
      
      
    });
    finalPrice = finalPrice + addOnPrice;
    finalPriceCompare = finalPriceCompare + addOnPriceCompare;

    if (finalPrice < finalPriceCompare) {
      // has discount
      bundlePriceHTML = '<span class="actual-price">'+customMoney(finalPrice/100)+'</span> <span class="compare-price">'+customMoney(finalPriceCompare/100)+'</span>';
      //console.log(bundlePriceHTML);
      $('.product-page-right .priceInfo').addClass('price-on-sale').html(bundlePriceHTML);
      $('.product-page-right .prices').attr('data-actual-price', finalPrice);
      $('.product-page-right .prices').attr('data-compare-price', finalPriceCompare);

    } else {
      // no discount
      bundlePriceHTML = '<span class="actual-price">'+customMoney(finalPrice/100)+'</span>';
      console.log(bundlePriceHTML);
      $('.product-page-right .prices .priceInfo').removeClass('price-on-sale').html(bundlePriceHTML);
    }

    console.log('addOnPrice', addOnPrice, 'addOnPriceCompare', addOnPriceCompare);
    console.log('finalPrice', finalPrice, 'finalPriceCompare', finalPriceCompare);
  }  
}

$(document).ready(function() {
  if ($('.customVariantPicker').length > 0) {
      var dataLabel = $('.customVariantPicker').attr('data-label');
      var orginalVariantElem = $('.customVariantBox .product-form__input--dropdown[data-label="'+dataLabel+'"]');
      var orginalVariantSelect = orginalVariantElem.find('select');
      var orginalVariantVal = orginalVariantElem.find('select').val();
      //console.log('customVariantPicker', dataLabel, orginalVariantElem.length);
      $('.customVariantBox .product-form__input--dropdown[data-label="'+dataLabel+'"]').hide();
      $('.customVariantPicker [data-value="'+orginalVariantVal+'"]').addClass('active');

      orginalVariantElem.find('select option').each(function() {
          console.log($(this).val());
          if ($(this).text().indexOf('Soldout') > -1) {
              $('.customVariantPicker [data-value="'+$(this).val()+'"]').addClass('disabled');
          }
      });

      $('body').on('click', '.customVariantPicker [data-value]', function() {
        var thisVal = $(this).attr('data-value');

        $('.customVariantPicker [data-value]').removeClass('active');
        $(this).addClass('active');
        console.log('customVariantPicker', thisVal);
        $('.customVariantBox .product-form__input--dropdown[data-label="'+dataLabel+'"] select').val(thisVal).trigger('change');
      });
  }
});

function matchVariantBundle(event) {
  var bundleOOS = false;
  $('.customVariantBox .product-form__input').each(function(index) {
    var thisVal = '';
    var $thisOpt = $(this);
    if ($(this).hasClass('product-form__input--pill') == true) {
      var bundleVal = '';

      thisVal = $(this).find('input:checked').val();
      var thisVal_1 = thisVal.replace(' | ', ' - ');
      var thisVal_2 = thisVal.split(' | ')[0];

      var $bundleSelectBox = $('.bundle-option-wrapper .selector-wrapper:eq('+index+')'); 
      $bundleSelectBox.find('select option').each(function() {
        var optText = $.trim($(this).text());
        if (optText.indexOf(thisVal_2) > -1) {
          bundleVal = $(this).val();
        }
        if ($(this).val() == 'oos') {
          $thisOpt.find('input[type=radio]').each(function() {
            var thisVal_22 = $(this).attr('value').split(' | ')[0];
            if (optText.indexOf(thisVal_22) > -1) {
              $(this).addClass('disabled');
            }
          });  
        }  
      });
      if (bundleVal != '') {
        $bundleSelectBox.find('select').val(bundleVal).trigger('change');
      }
    } else {
      var bundleVal = '';
      thisVal = $(this).find('.select__select').val();
      var thisVal_1 = thisVal.replace(' | ', ' - ');
      var thisVal_2 = thisVal.split(' | ')[0];
      var $bundleSelectBox = $('.bundle-option-wrapper .selector-wrapper:eq('+index+')'); 
      
      $bundleSelectBox.find('select option').each(function(index) {
        var optText = $.trim($(this).text());
        if (optText.indexOf(thisVal_2) > -1) {
          bundleVal = $(this).val();
        }
        if ($(this).val() == 'oos') {
          $thisOpt.find('select option').each(function() {
            var thisVal_22 = $(this).attr('value').split(' | ')[0];
            if (optText.indexOf(thisVal_22) > -1) {
              $(this).text($(this).text()+' - (Soldout)');
            }
          });
        }
      });
      
      if (bundleVal != '') {
        //console.log('tttt', $bundleSelectBox.find('label').text(), bundleVal);
        $bundleSelectBox.find('select').val(bundleVal).trigger('change');
      }
    }
    if (bundleVal == 'oos') {
      bundleOOS = true;
    }
  }); 
  if (bundleOOS == true) {
    $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Sold Out').attr('disabled', 'disabled');
  } else {
    $('.quanity-cart-row .add-to-cart input[type="submit"]').val('Add to Cart').removeAttr('disabled', 'disabled');
  }
  //console.log('bundleOOS', bundleOOS);
} 

!(function($){
	var isProductSLiderActive = false;
	var initProductSlider = function() {

		// Hide carousel controls when there are few items/slides
	    $('.product-section-new-main .product-section-new-block-container').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		    var windowWidth = $(window).width();

		    if (windowWidth >= 768 && slick.slideCount <= 5) {
		    	$('.product-section-new-main__carousel-control-left').hide();
		    	$('.product-section-new-main__carousel-control-right').hide();
		    }

		    if (windowWidth < 768 && slick.slideCount <= 2) {
		    	$('.product-section-new-main__carousel-control-left').hide();
		    	$('.product-section-new-main__carousel-control-right').hide();
		    }
		});

	    $('.product-section-new-main .product-section-new-block-container').each(function(elem){
	    	var autoplaySpeedValue = parseInt($(this).attr('data-speed'));
	    	$(this).slick({
		        arrows:         false,
		        autoplay:       true,
		        autoplaySpeed:  autoplaySpeedValue,
		        infinite:       true,
		        pauseOnFocus:   false,
		        pauseOnHover:   false,
		        slidesToShow:   5,
		        slidesToScroll: 1,
		        adaptiveHeight: true,
		        responsive: [
		        	
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1281,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					}
		        ]
		    });
	    });


	    isProductSLiderActive = true;

	    $(document).on('click', '.product-section-new-main__carousel-control-left', function(e){
	    	e.preventDefault();

	    	$(this).parent().find('.product-section-new-block-container').slick('slickPrev');
	    });

	    $(document).on('click', '.product-section-new-main__carousel-control-right', function(e){
	    	e.preventDefault();
	    	$(this).parent().find('.product-section-new-block-container').slick('slickNext');
	    });

	};

	$(document).ready(function(){
		initProductSlider();
	});
})(jQuery);